import { Button, Divider } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link as RouterLink } from 'react-router-dom';

import CarImg from '../images/hero/HeroRightImages/carImg.png';
import EngineIcon from '../images/hero/HeroRightImages/engineIcon.png';
import CarLoanIcon from '../images/hero/HeroRightImages/carLoanIcon.png';
import CarPaintIcon from '../images/hero/HeroRightImages/carPaintIcon.png';
import FairPriceIcon from '../images/hero/HeroRightImages/fairPriceIcon.png';
import ScannerIcon from '../images/hero/HeroRightImages/scannerIcon.png';
import WatchImg from '../images/hero/HeroRightImages/watchImg.png';

import AiDrivenLogo from '../../assets/gradeIcons/aiDrivenEngine.png';
import OBDScanner from '../../assets/gradeIcons/OBDScanner.png';
import UnbiasedCustomer from '../../assets/gradeIcons/unbiasedCustomer.png';

import one from '../images/queryComponent/oneICon.png';
import two from '../images/queryComponent/twoIcon.png';
import three from '../images/queryComponent/threeIcon.png';

import roadsideAssist from '../numberIcons/roadsideAssist.png';
import cities from '../numberIcons/cities.png';
import customerSupport from '../numberIcons/customerSupport.png';
import kilometer from '../numberIcons/kmDriven.png';
import warranty from '../numberIcons/warranty.png';
import inspected from '../numberIcons/inspected.png';
import { Link } from 'react-router-dom';
import recomended from '../../assets/images/recommended.png';

import Thailand from '../../assets/icons/cityIcons/thailand.png';

export const ThailandContent = {
  headerPage: {
    menuItems: (
      <>
        <li>
          <a aria-label="" href="#inspection-plans">
            แผนการตรวจสอบ
          </a>
        </li>
        <li>
          <a aria-label="" href="#how-it-works">
            วิธีการทำงาน
          </a>
        </li>
        <li>
          <a aria-label="" href="#why-wisedrive">
            ทำไมต้อง Wisedrive
          </a>
        </li>
        <li>
          <a aria-label="" href="#contact-us">
            ติดต่อเรา
          </a>
        </li>
      </>
    ),
    languages: [
      {
        id: 'en',
        label: 'EN',
      },
      {
        id: 'th',
        label: 'TH',
      },
    ],
  },
  heroPage: {
    headLine: (
      <div className="hero-headline">
        <img loading="lazy" src={CarImg} width="30px" alt="ภาพรถยนต์" />
        <p>กำลังซื้อรถมือสองอยู่หรือไม่?</p>
      </div>
    ),
    header: (
      <h2>
        ตรวจสอบรถมือสองก่อน
        <span style={{ color: 'red' }}>
          <br /> ไม่เสียใจภายหลัง!
        </span>
      </h2>
    ),
    subPoints: [
      'หลีกเลี่ยงค่าซ่อมแซมที่แพง',
      'ได้รับข้อมูลสภาพรถจริง',
      'ซื้อปลอดภัยไม่มีความเสี่ยง',
      'ตรวจสอบโดยผู้เชี่ยวชาญที่เชื่อถือได้',
    ],
    btnText: 'จองการตรวจสอบ',
    cardTitles: [
      {
        color: '#003cc5',
        content: (
          <>
            <h4>200+</h4>
            <p style={{ color: 'white' }}>จุดตรวจสอบที่ครอบคลุม</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={EngineIcon} alt="" />
            <p>เครื่องยนต์ & ระบบเกียร์</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={CarPaintIcon} alt="" />
            <p>ตรวจสอบรอยบุบและสี</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={ScannerIcon} alt="" />
            <p>การสแกน OBD2 ขั้นสูง</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={CarLoanIcon} alt="" />
            <p>ตรวจสอบไฟแนนซ์และกรมขนส่ง</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={FairPriceIcon} alt="" />
            <p>การันตีราคายุติธรรม</p>
          </>
        ),
      },
    ],
    rightFooter: (
      <>
        <p className="hero-right-footer-p">
          การตรวจสอบของเราช่วยลูกค้าประหยัดเงินไปแล้วกว่า{' '}
          <strong>THB 260</strong>
          สิบล้านรูปี
          โดยป้องกันข้อผิดพลาดจากเครื่องยนต์ที่ซ่อนอยู่และค่าซ่อมหลังการซื้อ
        </p>
        <p className="hero-right-footer-p">
          <strong style={{ color: 'red' }}>
            อย่าเสี่ยงกับเงินที่คุณหามาอย่างยากลำบาก -
            ตรวจสอบรถมือสองของคุณวันนี้!
          </strong>
        </p>
      </>
    ),
  },
  planDetails: {
    header: (
      <div className="inspection-header-container">
        <div>
          <h2 className="inspection-header">
            เราครอบคลุมทุกอย่างเพื่อปกป้องรถของคุณ
          </h2>
          <h2 className="inspection-header-red">ตรวจสอบ 200+ จุด</h2>
        </div>
        <div>
          <img
            loading="lazy"
            src={recomended}
            alt=""
            className="logo-web"
          ></img>

          <div className="mbl-View-only">
            <img
              loading="lazy"
              src={recomended}
              alt=""
              className="recomended-img"
            ></img>
            <RouterLink
              style={{
                color: '#003cc5',
                fontSize: '18px',
                border: '1px solid',
                borderColor: '#003cc5',
                padding: '5px',
                borderRadius: '6px',
              }}
              target="_blank"
              to={'/sample-report'}
            >
              <p
                style={{
                  color: 'rgb(0, 60, 197)',
                  fontFamily: 'matterThin',
                  fontSize: '12px',
                  paddingTop: '0px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  paddingLeft: '0px !important',
                }}
              >
                ตัวอย่างรายงาน
                <OpenInNewIcon fontSize="small" />
              </p>
            </RouterLink>
          </div>
        </div>
      </div>
    ),
    currency: 'THB',
    noteTaxes: 'รวมภาษีทั้งหมด',
    infoNote:
      'รายงานการตรวจสอบจะถูกส่งผ่าน WhatsApp ไปยังหมายเลขโทรศัพท์มือถือที่ลงทะเบียนไว้ในขณะที่ทำการจอง.',
    inspectionCardsArray: [
      {
        header: 'การตรวจสอบทางกายภาพ / ด้วยตนเอง',
        checkPoints: '135',
        inspectionItems: [
          'ตรวจสอบเครื่องยนต์และระบบเกียร์',
          'ตรวจสอบระบบไฟฟ้า',
          'ตรวจสอบชิ้นส่วนทางกลไก',
          'ตรวจสอบภายในและภายนอกรถ',
        ],
        additionalBenifits: {
          header: 'สิทธิประโยชน์เพิ่มเติม',
          data: [
            'ตรวจสอบรถที่เคยถูกน้ำท่วม, ตรวจสอบการซ่อมเครื่องยนต์ใหญ่',
            'ตรวจสอบการทำงานของแบตเตอรี่, ตรวจสอบการปลอมแปลงเลขไมล์',
            'ตรวจสอบระบบเบรก, ตรวจสอบระบบเชื้อเพลิง',
          ],
        },
      },
      {
        header: 'การตรวจสอบกรมขนส่ง & ตำรวจ',
        checkPoints: '29',
        inspectionItems: [
          'ตรวจสอบประวัติสินเชื่อและประกันภัย',
          'ตรวจสอบค่าปรับจราจรและบัญชีดำ',
          'ตรวจสอบความถูกต้องของทะเบียนรถและ พรบ.',
          'ตรวจสอบข้อมูลเจ้าของรถและยานพาหนะ',
        ],
        additionalBenifits: {
          header: 'สิทธิประโยชน์เพิ่มเติม',
          data: [
            'ตรวจสอบเอกสารปลอดภาระหนี้, ตรวจสอบวันหมดอายุของประกันภัย',
            'ตรวจสอบสถานะบัญชีดำ',
            'ตรวจสอบข้อมูลการฉ้อโกงและเอกสารทะเบียนรถกับฐานข้อมูลกรมขนส่ง',
          ],
        },
      },
      {
        header: 'การทดสอบเครื่องสแกน OBD2 ขั้นสูง',
        checkPoints: '76',
        inspectionItems: [
          'ตรวจสอบโมดูลควบคุมเครื่องยนต์ (ECM)',
          'ตรวจสอบโมดูลควบคุมระบบเกียร์',
          'ตรวจสอบโมดูลควบคุมตัวถังรถ (BCM)',
          'ตรวจสอบและวิเคราะห์รหัสข้อผิดพลาด',
        ],
        additionalBenifits: {
          header: 'สิทธิประโยชน์เพิ่มเติม',
          data: [
            'วิเคราะห์ความเป็นไปได้ของความเสียหายเครื่องยนต์, วิเคราะห์ความเสียหายของระบบเกียร์',
            'ตรวจสอบเสถียรภาพของรถที่ความเร็วสูงด้วยเครื่องสแกน OBD-2 ขั้นสูง',
            'ตรวจสอบการป้องกันค่าซ่อมแพง',
          ],
        },
      },
      {
        header: 'บริการสนับสนุนทางเทคนิคเพิ่มเติม',
        checkPoints: '76',
        inspectionItems: [
          'การประเมินราคารถที่เป็นธรรม',
          'การประมาณค่าใช้จ่ายซ่อมแซม',
          'คำแนะนำจากช่างผู้เชี่ยวชาญ',
          'การรับประกันเพิ่มเติมสูงสุด 2 ปี',
        ],
      },
    ],
    partPaymentAmount: 500,
    partialBtnText: 'ชำระเงินล่วงหน้า THB 500 บาท',
    btnBookInspection: 'จองการตรวจสอบ',
    sampleBtnText: 'ตัวอย่างรายงาน',
    steps: [
      'ลงทะเบียนด้วยหมายเลขโทรศัพท์มือถือ',
      'ป้อนรายละเอียดรถ',
      'เลือกเมืองสำหรับการตรวจสอบ',
      'ยืนยันรายละเอียดการชำระเงิน',
    ],

    formHeader: (
      <>
        ปลดล็อกมาตรฐาน
        <br /> การตรวจสอบรถยนต์
      </>
    ),
    errorName: 'กรุณากรอกชื่อ',
    labelName: 'ชื่อ',
    errorMobile: 'กรุณากรอกหมายเลขโทรศัพท์',
    labelMobile: 'หมายเลขโทรศัพท์มือถือ',
    otpSuccessMsg: 'ส่งรหัส OTP ผ่าน SMS ไปยังหมายเลขของคุณแล้ว',
    resendOtpLbl: 'ส่งรหัส OTP อีกครั้ง',
    sendOtpLbl: 'ส่งรหัส OTP',
    entrrOtpLbl: 'ป้อนรหัส OTP',
    entrrOtpErrorLbl: 'กรุณาป้อนรหัส OTP ที่ถูกต้อง',
    verifyOtpBth: 'ยืนยันรหัส OTP',
    otpNote: (
      <>
        เมื่อคุณติดต่อเรา คุณยอมรับ{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/th/inspection-terms-and-conditions'}
        >
          <strong>เงื่อนไข การให้บริการ</strong> และ{' '}
          <strong>นโยบายความเป็นส่วนตัว</strong>
        </RouterLink>
      </>
    ),
    registerHeader: 'ป้อนหมายเลขทะเบียนรถ',
    searchBtn: 'ค้นหา',
    carMakeLbl: 'ยี่ห้อ',
    carModelLbl: 'รุ่น',
    carMfYearLbl: 'ปีที่ผลิต',
    carTypeLbl: 'ประเภท',
    carColorLbl: 'สี',
    confirmBtn: 'ใช่, ยืนยันรถ',
    skipBtn: 'ข้ามไปที่การชำระเงิน',
    cityIconArray: [
      {
        name: 'Bangkok',
        icon: Thailand,
      },
      {
        name: 'Chiang Mai',
        icon: Thailand,
      },
    ],
    selectTimeLbl: 'เลือกเวลา',
    selectDateLbl: 'เลือกวันที่',
    cityLbl: 'เมือง',
    addressLbl: 'ป้อนที่อยู่สำหรับการตรวจสอบ',
    confirmInspectionBtn: 'ยืนยันการตรวจสอบ',
    payHeadr: 'สรุป',
    pkgAmtLbl: 'ยอดรวมแพ็คเกจ',
    inspCurrencyLbl: ' การตรวจสอบ x THB',
    totalAmtLbl: 'ยอดรวมทั้งหมด',
    partialBtnNote: 'ยอดเงินที่เหลือต้องชำระหลังจากการตรวจสอบรถเสร็จสิ้น',
    fullBtnText: 'ชำระเงินเต็มจำนวน',
    fullBtnNote: (
      <>
        <strong>เมื่อเลือกการชำระเงินเต็มจำนวน คุณยอมรับ</strong>{' '}
        <strong>เงื่อนไขการให้บริการ</strong> และ{' '}
        <strong>นโยบายความเป็นส่วนตัว</strong>
      </>
    ),
    termsTxt: (
      <>
        เมื่อคุณติดต่อเรา คุณยอมรับ{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/th/inspection-terms-and-conditions'}
        >
          <strong>เงื่อนไข การให้บริการ</strong> และ{' '}
          <strong>นโยบายความเป็นส่วนตัว</strong>
        </RouterLink>
        ของ Wisedrive Technologies Pvt Ltd
      </>
    ),
    secureLbl: 'การชำระเงินได้รับการรักษาความปลอดภัยโดย',
    whatsappFooterTxt: (
      <>
        ทักเราทาง{' '}
        <span
          style={{
            fontSize: '16px',
            fontFamily: 'matterBold',
          }}
        >
          WhatsApp ที่ +66 81 899 4420{' '}
        </span>{' '}
        สำหรับข้อสงสัย ตั้งแต่ 9 โมงเช้า - 1 ทุ่ม จันทร์ - เสาร์
      </>
    ),
    brandsCovered: 'แบรนด์ที่ครอบคลุม',
    brandCoveredHeader: 'แบรนด์ที่ครอบคลุมในแต่ละแพ็คเกจการตรวจสอบ',
    brandsCoveredNote:
      'รถทุกประเภท เช่น แฮทช์แบค, ซีดาน, MUV, MPV, SUV ครอบคลุมในทุกแบรนด์',
    standardLbl: 'มาตรฐาน',
    luxaryLbl: 'หรูหรา',
    brandsStandardArray: [
      'MARUTHI SUZUKI',
      'HYUNDAI',
      'HONDA',
      'KIA',
      'TOYOTA',
      'VOLKSWAGEN',
      'SKODA',
      'RENAULT',
      'NISSAN',
      'MAHINDRA',
      'TATA MOTORS',
      'FORD',
      'FIAT',
      'DATSUN',
      'MISTUBISHI',
      'Chery',
      'Isuzu',
      'Mazda',
      'Mitsubishi',
      'Perodua',
      'Proton',
      'Peugeot',
    ],
    brandsLuxuryArray: [
      'MERCHEDES BENZ',
      'BMW',
      'AUDI',
      'VOLVO',
      'FERRARI',
      'BUGATTI',
      'Range Rover',
      'Lexus ',
      'Mini Cooper',
    ],
    paymentFormFooter: (
      <>
        เมื่อคุณติดต่อเรา คุณยอมรับ{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/th/inspection-terms-and-conditions'}
        >
          <strong>เงื่อนไข การให้บริการ</strong> และ{' '}
          <strong>นโยบายความเป็นส่วนตัว</strong>
        </RouterLink>
        ของ Wisedrive Technologies Pvt Ltd
      </>
    ),
  },
  flexiPay: {
    header: (
      <h2>
        ปรับแต่งการรับประกันรถยนต์ของคุณด้วย
        <br /> <span style={{ color: '#ff7858' }}>‘เฟล็กซี่-เพย์’</span> ..
      </h2>
    ),
    cardContent: [
      {
        color: '#003cc5',
        content: (
          <>
            <div className="flexi-quarterly">
              <div className="flexi-card-header">
                <h6 style={{ color: 'black' }}>
                  แผนการชำระเงิน <br />
                  รายไตรมาส
                </h6>
                <div className="flexi-card-headright">
                  <p>เริ่มต้นที่</p>

                  <span style={{ fontFamily: 'matter' }}>
                    THB
                    <p
                      style={{
                        fontSize: '22px',
                        fontFamily: 'matterSemibold',
                      }}
                    >
                      1499
                    </p>
                  </span>
                </div>
              </div>
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    0-3 <br /> เดือน
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-label-p">ลูกค้า</p>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">ร่วมจ่าย</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-label-p">Wisedrive</p>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">การจ่ายเงิน</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    4-6 <br /> เดือน
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">ร่วมจ่าย</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">การจ่ายเงิน</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    7-9 <br /> เดือน
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">ร่วมจ่าย</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">การจ่ายเงิน</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    10-12 <br /> เดือน
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">ร่วมจ่าย</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">การจ่ายเงิน</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <a aria-label="" href="/th#contact-us">
                  <Button
                    variant="contained"
                    sx={{
                      color: 'white',
                      fontSize: '18px',
                      fontFamily: 'matterMedium',
                      margin: '10px',
                      backgroundColor: '#e61f93',
                    }}
                  >
                    ติดต่อฝ่ายขาย
                  </Button>
                </a>
              </div>
            </div>
          </>
        ),
      },
      {
        content: (
          <>
            <div>
              <div className="flexi-halfCard-wrap">
                <div className="flexi-halfyearly">
                  <div className="flexi-card-header">
                    <h6 style={{ color: 'black' }}>
                      แผนการชำระเงิน <br />6 เดือน
                    </h6>
                    <div className="flexi-card-headright">
                      <p>เริ่มต้นที่</p>

                      <span style={{ fontFamily: 'matter' }}>
                        THB
                        <p
                          style={{
                            fontSize: '22px',
                            fontFamily: 'matterSemibold',
                          }}
                        >
                          2999
                        </p>
                      </span>
                    </div>
                  </div>
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        0-6 <br /> เดือน
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">ลูกค้า</p>
                      <p className="card-percent-p">10%</p>
                      <p className="card-label-p">ร่วมจ่าย</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Wisedrive</p>
                      <p className="card-percent-p">90%</p>
                      <p className="card-label-p">การจ่ายเงิน</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        7-12 <br /> เดือน
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-percent-p">00%</p>
                      <p className="card-label-p">ร่วมจ่าย</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-percent-p">100%</p>
                      <p className="card-label-p">การจ่ายเงิน</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <a aria-label="" href="/th#contact-us">
                      <Button
                        variant="contained"
                        sx={{
                          color: 'white',
                          fontSize: '18px',
                          fontFamily: 'matterMedium',
                          margin: '10px',
                          backgroundColor: '#950000',
                        }}
                      >
                        ติดต่อฝ่ายขาย
                      </Button>
                    </a>
                  </div>
                </div>

                <div className="flexi-yearly">
                  <div className="flexi-card-header">
                    <h6 style={{ color: 'black' }}>
                      แผนการชำระเงิน <br />
                      รายปี
                    </h6>
                    <div className="flexi-card-headright">
                      <p>เริ่มต้นที่</p>
                      <span style={{ fontFamily: 'matter' }}>
                        THB
                        <p
                          style={{
                            fontSize: '22px',
                            fontFamily: 'matterSemibold',
                          }}
                        >
                          4999
                        </p>
                      </span>
                    </div>
                  </div>
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        0-12 <br /> เดือน
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">ลูกค้า</p>
                      <p className="card-percent-p">00%</p>
                      <p className="card-label-p">ร่วมจ่าย</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Wisedrive</p>
                      <p className="card-percent-p">100%</p>
                      <p className="card-label-p">การจ่ายเงิน</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <a aria-label="" href="/th#contact-us">
                      <Button
                        variant="contained"
                        sx={{
                          color: 'white',
                          fontSize: '18px',
                          fontFamily: 'matterMedium',
                          margin: '10px',
                          backgroundColor: '#202020',
                        }}
                      >
                        ติดต่อฝ่ายขาย
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
              <div className="flexi-note">
                <p>
                  * ร่วมจ่าย คือเปอร์เซ็นต์ของจำนวนเงินที่ลูกค้าต้องจ่าย
                  สำหรับอะไหล่ที่อยู่ภายใต้การรับประกันในช่วงระยะเวลาการชำระเงินดังกล่าว
                  โปรดอ่านเงื่อนไขการรับประกันที่{' '}
                  <a aria-label="" href=" https://wisedrive.com">
                    {' '}
                    https://wisedrive.com
                  </a>
                </p>
                <p>
                  ** ค่าลากจูงและค่าดำเนินการต้องชำระแยกต่างหาก
                  โดยคิดค่าบริการตามระยะทางที่รถถูกลาก
                </p>
              </div>
            </div>
          </>
        ),
      },
    ],
  },
  comparePage: {
    header: 'Wisedrive เหนือกว่าการตรวจสอบรถยนต์มือสองทั่วไป',
    subTitle:
      'สัมผัสประสบการณ์ความสบายใจที่ไม่มีใครเทียบได้ ด้วยการตรวจสอบอย่างละเอียด รายงานที่ครบถ้วน และการรับประกันความมั่นใจสูงสุดสำหรับผู้ซื้อรถมือสองจาก Wisedrive',
    wiseDrivePoints: {
      header: 'แนวทางของ Wisedrive',
      content: [
        {
          point: (
            <p>
              ตรวจสอบเครื่องยนต์ ระบบเกียร์ ระบบไฟฟ้า และส่วนประกอบทางกลไก{' '}
              <span className="highlet">
                เพื่อให้แน่ใจว่าทุกชิ้นส่วนสำคัญอยู่ในสภาพที่สมบูรณ์
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              จัดทำรายงานการตรวจสอบอย่างละเอียด พร้อม{' '}
              <span className="highlet">รูปถ่ายคุณภาพสูงและผลการวิเคราะห์</span>
              เพื่อให้เข้าใจสภาพของรถได้อย่างชัดเจน
            </p>
          ),
        },
        {
          point: (
            <p>
              ใช้ <span className="highlet">OBD-2, ECM และ BCM</span>{' '}
              เพื่อตรวจสอบระบบอิเล็กทรอนิกส์ทั้งหมด
              ให้แน่ใจว่าระบบทำงานได้อย่างถูกต้อง
            </p>
          ),
        },
        {
          point: (
            <p>
              ให้ <span className="highlet">คำแนะนำเฉพาะบุคคล</span> และ{' '}
              <span className="highlet">ประมาณการค่าซ่อมที่แม่นยำ</span>{' '}
              โดยอ้างอิงจากผลการตรวจสอบ{' '}
              <span className="highlet">
                เพื่อช่วยให้คุณเข้าใจค่าใช้จ่ายที่อาจเกิดขึ้น
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              มอบ <span className="highlet">การรับประกัน 6 เดือน</span> และ{' '}
              <span className="highlet">การรับซื้อคืน</span>{' '}
              เพื่อให้คุณมั่นใจและปลอดภัยทางการเงิน
            </p>
          ),
        },
        {
          point: (
            <p>
              ตรวจสอบ{' '}
              <span className="highlet">
                ความถูกต้องทางการเงิน สถานะประกัน ภาษีรถยนต์ที่ค้างชำระ
              </span>{' '}
              และ <span className="highlet">ประวัติอาชญากรรมของรถ</span>{' '}
              เพื่อให้แน่ใจว่าไม่มีปัญหาทางกฎหมายหรือทางการเงินที่ซ่อนอยู่
            </p>
          ),
        },
      ],
    },
    comparePoints: {
      header: 'การตรวจสอบทั่วไป',
      content: [
        {
          point: (
            <p>
              ให้บริการตรวจสอบทั่วไปที่ครอบคลุมพอสมควร{' '}
              <span className="highlet">แต่ยังขาดความลึกซึ้งในบางจุด</span>
            </p>
          ),
        },
        {
          point: (
            <p>
              จัดทำรายงานผลการตรวจสอบพร้อมผลวิเคราะห์{' '}
              <span className="highlet">
                แต่บางครั้งอาจไม่มีหลักฐานเป็นภาพถ่ายที่ชัดเจน
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              ใช้เครื่องมือตรวจวิเคราะห์ แต่{' '}
              <span className="highlet">
                อาจไม่ได้ตรวจสอบระบบทั้งหมดอย่างละเอียดและสม่ำเสมอ
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              ให้คำแนะนำและประมาณการค่าซ่อม{' '}
              <span className="highlet">
                ซึ่งอาจไม่ตรงกับความต้องการของลูกค้าเสมอไป
              </span>{' '}
              และมักจะเอื้อประโยชน์ต่ออู่ซ่อมรถมากกว่าผู้ซื้อ
            </p>
          ),
        },
        {
          point: (
            <p>
              มีการรับประกันและความพึงพอใจ{' '}
              <span className="highlet">
                แต่โดยทั่วไปจะมีระยะเวลาสั้นกว่าและครอบคลุมน้อยกว่า
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              ตรวจสอบข้อมูลทางการเงินและประกันภัย{' '}
              และมีการตรวจสอบเพิ่มเติมบางอย่าง{' '}
              <span className="highlet">
                แต่รายละเอียดอาจไม่ครบถ้วนเท่าที่ควร
              </span>
            </p>
          ),
        },
      ],
    },
  },
  onlyWhatsApp: {
    header: (
      <>
        <h2 className="whatsapp-mobile-header">
          ตรวจสอบสภาพรถ <br />
          อย่างเป็นกลาง, <br />
          ขับเคลื่อนด้วยเทคโนโลยี, <br />
          มุ่งเน้นลูกค้า, <br />
          และทันสมัยที่สุด
        </h2>
        <h2 className="whatsapp-header">
          ตรวจสอบสภาพรถอย่างเป็นกลาง, ขับเคลื่อนด้วยเทคโนโลยี, มุ่งเน้นลูกค้า
          และทันสมัยที่สุด
        </h2>
        <p>
          ที่ WiseDrive คุณจะได้รับประสบการณ์คุณภาพสูงสุด
          ด้วยการตรวจสอบที่เป็นกลาง, เทคโนโลยีขั้นสูง, มุ่งเน้นลูกค้าเป็นหลัก
          และใช้วิธีการที่ล้ำสมัยสำหรับการตรวจสอบรถยนต์มือสอง
        </p>
      </>
    ),
    gradeCardsData: [
      {
        src: UnbiasedCustomer,
        header: 'การตรวจสอบอย่างเป็นกลางและมุ่งเน้นลูกค้า',
        content:
          'เราทำการตรวจสอบรถอย่างโปร่งใสและเป็นกลาง โดยให้การประเมินที่เป็นวัตถุประสงค์ เพื่อรับรองคุณภาพและความน่าเชื่อถือของรถยนต์สูงสุด',
      },
      {
        src: AiDrivenLogo,
        header: 'AI วิเคราะห์เสียงเครื่องยนต์',
        content:
          'WiseDrive ใช้ AI ขั้นสูงในการวิเคราะห์เสียงเครื่องยนต์ โดยเปรียบเทียบข้อมูลนับล้านจุดของรถที่คล้ายกันทั่วประเทศ',
      },
      {
        src: OBDScanner,
        header: 'การวิเคราะห์ด้วยเครื่องสแกน OBD-2 ขั้นสูง',
        content:
          'การวิเคราะห์โมดูลควบคุมเครื่องยนต์ (ECM), โมดูลควบคุมตัวถัง (BCM), และโมดูลควบคุมเกียร์ (TCM) ของรถคุณ ด้วยเครื่องสแกน OBD-2 รุ่นล่าสุด',
      },
    ],
  },
  brandGrade: {
    header: (
      <>
        <h2>การรับประกันระดับโชว์รูมสำหรับรถของคุณ</h2>
        <p className="grade-description">
          WiseDrive
          ร่วมมือกับศูนย์บริการที่ได้รับอนุญาตจากทุกแบรนด์รถยนต์ที่จำหน่ายในอินเดีย
          และให้ความคุ้มครองการรับประกันที่ครอบคลุมทั่วประเทศ
          ด้วยอัตราการอนุมัติการเคลมถึง 98% ภายใน 24 ชั่วโมงหลังจากการร้องขอ
          เรามีบริการช่วยเหลือฉุกเฉินและการสนับสนุนการรับประกันทั่วอินเดียสำหรับลูกค้าของเรา
        </p>
      </>
    ),
    card1: {
      header: 'อะไหล่ไฟฟ้า',
      content:
        'รับประกันระบบสายไฟ, แบตเตอรี่, ระบบอินโฟเทนเมนท์, ไฟหน้าและหลอดไฟ',
    },

    card2: {
      header: 'อะไหล่เครื่องกล',
      content: 'ระบบช่วงล่าง, โช้คอัพ, แขนล่างของระบบกันสะเทือน',
    },
    card3: {
      header: (
        <h6 style={{ color: 'white' }}>
          ชิ้นส่วนเครื่องยนต์ <br />
          และระบบส่งกำลัง
        </h6>
      ),
      content:
        'ชิ้นส่วนทั้งหมดของเครื่องยนต์และระบบส่งกำลังอยู่ภายใต้โปรแกรมการรับประกันแบบครอบคลุมของ WiseDrive รวมถึงระบบเกียร์อัตโนมัติด้วย',
      content1: 'เราสนับสนุนการตรวจสอบของเราด้วยการรับประกันฟรีสำหรับรถของคุณ',
    },
    card4: {
      header: 'บริการช่วยเหลือฉุกเฉิน',
      content: 'รวมอยู่ในโปรแกรมการรับประกันแบบครอบคลุม',
    },
    card5: {
      header: 'การรับประกันระบบปรับอากาศ',
      content: 'คอมเพรสเซอร์แอร์, คอยล์เย็น, สายไฟระบบแอร์, ตัวนำไฟฟ้าระบบแอร์',
    },
  },
  queryPage: {
    header: (
      <div>
        <p className="query-sub-header">วิธีการทำงาน ?</p>
        <h2 style={{ color: 'black' }}>
          การซื้อรถมือสองไม่เคย <span style={{ color: '#003cc4' }}>มั่นใจ</span>{' '}
          ขนาดนี้มาก่อน!
        </h2>
        <p style={{ color: 'black' }}>
          ส่งข้อความ "HI" ทาง WhatsApp มาที่ +66 81 899 4420
          เพื่อซื้อแผนการตรวจสอบ, จองตรวจสอบ,
          <br /> นัดหมายตรวจสอบ, เปลี่ยนเวลาตรวจสอบ
          หรือพูดคุยกับผู้เชี่ยวชาญเกี่ยวกับรถของคุณ
          <strong>เพียงแค่ส่ง "Hi" เราพร้อมช่วยเหลือคุณ</strong>
        </p>
      </div>
    ),
    cardsData: [
      {
        img: one,
        headder: 'ซื้อแผนการตรวจสอบ',
        body: (
          <>
            <p>เลือกแพ็กเกจการตรวจสอบที่ดีที่สุดสำหรับรถของคุณ</p>
            <p>ซื้อการตรวจสอบก่อนซื้อรถ เพื่อให้มั่นใจในคุณภาพหลังการซื้อ</p>
          </>
        ),
      },
      {
        img: two,
        headder: 'นัดหมายการตรวจสอบ',
        body: (
          <>
            <p>
              นัดหมายตรวจสอบออนไลน์ / ผ่าน WhatsApp หรือโทรหาเราที่ +91 73380
              73380 ได้ตลอดเวลา
            </p>
            <p>คุณสามารถนัดหมายตรวจสอบได้ทุกที่ในเมืองโดยไม่ยุ่งยาก</p>
          </>
        ),
      },
      {
        img: three,
        headder: 'รับรายงานภายใน 2 ชั่วโมง',
        body: (
          <>
            <p>
              รับรายงานการตรวจสอบรถของคุณภายใน 2
              ชั่วโมงหลังจากเสร็จสิ้นการตรวจสอบ
            </p>
            <p>
              เราจะส่งลิงก์รายงานผ่าน WhatsApp ซึ่งคุณสามารถคลิกเพื่อดูรายงานได้
            </p>
          </>
        ),
      },
    ],
    advisory: (
      <>
        <p>
          ผู้เชี่ยวชาญของเราจะให้คำแนะนำเกี่ยวกับปัญหาทั้งหมดของรถและช่วยคุณเลือกซื้อรถที่เหมาะสม
        </p>
        <p
          style={{
            color: '#003cc4',
            paddingTop: '0px',
            fontFamily: 'matterMedium',
          }}
        >
          การซื้อรถหลังจากตรวจสอบกับ WiseDrive รับประกันความสบายใจ
        </p>
      </>
    ),
  },
  pricePage: {
    header: (
      <>
        เรานำเสนอคุณภาพ,{' '}
        <span style={{ fontFamily: 'matterThin' }}>
          ด้วยเทคโนโลยีที่ดีที่สุดและ
          <br />
          ผู้เชี่ยวชาญด้านยานยนต์ในการตรวจสภาพรถ
        </span>
      </>
    ),
    subTitle:
      'ลูกค้ามากกว่า 200,000+ คนไว้วางใจให้เราตรวจสอบรถมือสองก่อนตัดสินใจซื้อ',
    numberCardData: [
      {
        image: inspected,
        number: '200,000+',
        text: 'ลูกค้าทั่วประเทศอินเดียไว้วางใจเราในการตรวจสอบรถมือสองก่อนซื้อ',
      },
      {
        image: warranty,
        number: '75,000+',
        text: 'ลูกค้าซื้อการรับประกันของเราหลังการซื้อเพื่อการเป็นเจ้าของที่ไร้กังวล',
      },
      {
        image: kilometer,
        number: '80,00,000+',
        text: 'กิโลเมตรที่ลูกค้าเดินทางด้วยการรับประกันของ Wisedrive',
      },
      {
        image: cities,
        number: '10+ เมือง',
        text: 'เราครอบคลุมกว่า 10 เมืองและมากกว่า 7,000+ รหัสไปรษณีย์ทั่วอินเดีย',
      },
      {
        image: customerSupport,
        number: 'ฝ่ายบริการลูกค้า',
        text: 'ฝ่ายบริการลูกค้าของเราพร้อมให้บริการตลอด 24/7 สำหรับข้อสงสัยเกี่ยวกับการรับประกัน',
      },
      {
        image: roadsideAssist,
        number: 'บริการช่วยเหลือฉุกเฉิน',
        text: 'ติดขัดที่ไหน? โทรหาเราสำหรับบริการช่วยเหลือฉุกเฉินภายใน 30 นาที',
      },
    ],
  },
  contactUsPage: {
    header: 'ติดต่อเรา',
    subTitle:
      'Whatsapp, โทรศัพท์ หรือกรอกแบบฟอร์มเพื่อเรียนรู้ว่า Wisedrive สามารถช่วยปกป้องการลงทุนของคุณในการซื้อรถมือสองได้อย่างไร',
    email: 'support.th@wisedrive.com',
    mobile1: '+66 81 899 4420',
    mobile2: '+66 81 899 4420',
    dec1header: 'ฝ่ายบริการลูกค้า',
    dec1Content: (
      <>
        <p style={{ paddingTop: '0px' }}>
          WiseDrive Technologies (Thailand) Limited
        </p>
        <p style={{ paddingTop: '0px' }}>450/2 อาคารบุญญสถิตย์</p>
        <p style={{ paddingTop: '0px' }}>ชั้น 2 ถนนพระราม 3 แขวงบางโคล่</p>
        <p style={{ paddingTop: '0px' }}>เขตบางคอแหลม กรุงเทพมหานคร 10120</p>
      </>
    ),

    dec2Header: 'ข้อเสนอแนะและคำแนะนำ',
    dec2Content:
      'เรามุ่งมั่นพัฒนา Wisedrive อย่างต่อเนื่อง คำแนะนำของคุณมีความสำคัญต่ออนาคตของการตรวจสอบรถมือสองในอินเดีย',
    formHeader: 'ติดต่อเรา',
    phoneCode: 66,
    formSubtitle: 'คุณสามารถติดต่อเราได้ตลอดเวลา',
    fromLableName: 'ชื่อของคุณ',
    fromLableEmail: 'อีเมลของคุณ',
    fromLablePhone: 'เบอร์โทรศัพท์',
    fromLableHelpText: 'เราสามารถช่วยอะไรคุณได้บ้าง?',
    formBtnText: 'ส่งข้อความ',
    formTerms: (
      <>
        การติดต่อเราถือว่าคุณยอมรับ
        <span style={{ fontFamily: 'matterBold' }}>
          {' '}
          ข้อกำหนดและเงื่อนไข{' '}
        </span>{' '}
        และ{' '}
        <span style={{ fontFamily: 'matterBold' }}>นโยบายความเป็นส่วนตัว</span>
      </>
    ),
  },
  reviewPage: {
    header: 'ประสบการณ์และรีวิวจากลูกค้า',
    subTitle:
      'ดูว่าความเชี่ยวชาญของเราช่วยให้คุณมั่นใจในการซื้อรถมือสองได้อย่างไร',
    reviewsData: [
      {
        reviewer_name: 'Mallikarjun',
        car: 'Hyundai i10',
        description:
          'บริการตรวจสอบของ Wisedrive เปลี่ยนแปลงทุกอย่างสำหรับฉัน! ฉันกำลังดูรถมือสองที่ดูสมบูรณ์แบบ แต่การตรวจสอบอย่างละเอียดพบปัญหาที่ซ่อนอยู่บางอย่าง สุดท้ายฉันสามารถต่อรองราคาที่ดีกว่าได้ด้วยรายงานรายละเอียดของพวกเขา แนะนำอย่างยิ่ง!',
      },
      {
        reviewer_name: 'Nikita Sharma',
        car: 'Toyota Glanza',
        description:
          'ในฐานะที่เป็นผู้ซื้อรถครั้งแรก ฉันรู้สึกกังวลเกี่ยวกับการซื้อรถมือสอง แต่ Wisedrive ทำให้กระบวนการนี้ง่ายขึ้นมาก ผู้ตรวจสอบมาตรงเวลา เป็นมืออาชีพ และอธิบายทุกอย่างให้เข้าใจง่าย รายงานมีความละเอียดและทำให้ฉันมั่นใจในการซื้อของฉัน',
      },
      {
        reviewer_name: 'Dilip Patel',
        car: 'Maruti Swift',
        description:
          'Wisedrive ช่วยให้ฉันไม่ต้องซื้อรถที่มีปัญหา! รถดูดีจากภายนอก แต่ผู้ตรวจสอบพบปัญหาทางกลไกหลายอย่าง บริการของพวกเขาคุ้มค่ามากหากคุณต้องการหลีกเลี่ยงการถูกหลอกเมื่อซื้อรถมือสอง',
      },
      {
        reviewer_name: 'Dharmesh Soni',
        car: 'MG Hector',
        description:
          'ฉันใช้ Wisedrive มาแล้วสองครั้ง และทั้งสองครั้งบริการของพวกเขาก็ยอดเยี่ยม ผู้ตรวจสอบมีความรู้และไม่เร่งรีบในกระบวนการ รายงานที่ละเอียดช่วยให้ฉันตัดสินใจได้อย่างมั่นใจ บริการที่ต้องใช้สำหรับผู้ซื้อรถมือสอง!',
      },
      {
        reviewer_name: 'Swati Gorakh',
        car: 'Skoda Octavia',
        description:
          'ประทับใจมากกับ Wisedrive! ผู้ตรวจสอบละเอียดมากและพบปัญหาเล็กน้อยที่ฉันไม่เคยสังเกตเห็น แม้แต่ผู้ขายยังยอมรับว่ามีปัญหาบางอย่างแต่ไม่สำคัญมาก ฉันรู้สึกมั่นใจขึ้นมากหลังจากใช้บริการนี้',
      },
      {
        reviewer_name: 'Rudra Gowda',
        car: 'Hyundai Venue',
        description:
          'Wisedrive เป็นบริการที่ต้องมีหากคุณกำลังซื้อรถมือสอง รายงานการตรวจสอบของพวกเขามีรายละเอียดและเข้าใจง่าย ผู้ตรวจสอบตรวจสอบทุกจุดอย่างละเอียด ฉันดีใจมากที่ใช้บริการของพวกเขาก่อนตัดสินใจซื้อ',
      },
      {
        reviewer_name: 'Chetana',
        car: 'Volkswagen Polo',
        description:
          'ตอนแรกฉันลังเลที่จะทำการตรวจสอบ แต่ตอนนี้ฉันดีใจมากที่ทำ! Wisedrive พบปัญหากับระบบส่งกำลังที่อาจทำให้ฉันต้องเสียเงินจำนวนมาก บริการของพวกเขาดีมากและคุ้มค่ากับการลงทุนแน่นอน',
      },
      {
        reviewer_name: 'Gomti',
        car: 'Toyota Fortuner',
        description:
          'ฉันเคยลังเลเกี่ยวกับการซื้อรถมือสอง แต่ Wisedrive ทำให้กระบวนการนี้ปราศจากความเครียด การตรวจสอบของพวกเขามีความละเอียดมาก และรายงานทำให้ฉันมั่นใจว่าฉันกำลังตัดสินใจซื้อที่ดี แนะนำสำหรับทุกคนที่กำลังมองหารถมือสอง!',
      },
      {
        reviewer_name: 'Naduvinahalli Kariyappa',
        car: 'Ford Endeavour',
        description:
          'ผู้ตรวจสอบจาก Wisedrive เป็นมิตร มีความเป็นมืออาชีพ และตรวจสอบอย่างละเอียด รายงานครอบคลุมทุกสิ่งที่ฉันจำเป็นต้องรู้ และการบริการลูกค้าของพวกเขาก็ยอดเยี่ยม ฉันรู้สึกมั่นใจขึ้นเพราะมีข้อมูลทั้งหมดก่อนซื้อ',
      },
      {
        reviewer_name: 'Rajat Chaudhry',
        car: 'Mahindra Scorpio',
        description:
          'บริการตรวจสอบของ Wisedrive ยอดเยี่ยมมาก! พวกเขาให้รายงานที่ละเอียดซึ่งช่วยให้ฉันต่อรองราคาได้ดีกว่า ผู้ตรวจสอบมีความรู้และตอบคำถามของฉันทั้งหมด ฉันจะใช้บริการของพวกเขาอีกแน่นอนสำหรับการซื้อรถในอนาคต',
      },
    ],
    buttonText: '1500+ รีวิวบน Google',
  },
  faqPage: {
    header: 'คำถามที่พบบ่อย',
    subtitle:
      'ทุกสิ่งที่คุณจำเป็นต้องรู้เกี่ยวกับผลิตภัณฑ์และการเรียกเก็บเงิน ไม่พบคำตอบที่คุณต้องการ? ติดต่อเรา',
    faqData: [
      {
        question: 'Wisedrive มีบริการตรวจสอบรถยนต์มือสองอะไรบ้าง?',
        answer:
          'Wisedrive ให้บริการตรวจสอบรถยนต์มือสองอย่างครบวงจร ครอบคลุมชิ้นส่วนสำคัญ เช่น เครื่องยนต์ ระบบเกียร์ ระบบเบรก และระบบไฟฟ้า',
      },
      {
        question: 'ฉันสามารถจองการตรวจสอบรถได้อย่างไร?',
        answer:
          'คุณสามารถจองการตรวจสอบได้ผ่านเว็บไซต์หรือแอปพลิเคชันของเรา โดยเลือกแพ็กเกจที่ต้องการและกำหนดวันนัดหมาย',
      },
      {
        question: 'การตรวจสอบรถยนต์มือสองของ Wisedrive มีอะไรบ้าง?',
        answer:
          'การตรวจสอบของเราครอบคลุมกว่า 200 จุดสำคัญ รวมถึงระบบเครื่องกล ระบบไฟฟ้า และระบบความปลอดภัย',
      },
      {
        question: 'กระบวนการตรวจสอบทำงานอย่างไร?',
        answer:
          'ช่างผู้เชี่ยวชาญจะทำการตรวจสอบรถของคุณที่สถานที่ของคุณหรืออู่พันธมิตร และจะส่งรายงานรายละเอียดหลังการตรวจสอบ',
      },
      {
        question: 'โดยทั่วไปแล้ว การตรวจสอบรถใช้เวลานานแค่ไหน?',
        answer:
          'การตรวจสอบใช้เวลาประมาณ 1-2 ชั่วโมง ขึ้นอยู่กับสภาพของรถและแพ็กเกจที่เลือก',
      },
      {
        question: 'ฉันสามารถขอรับการตรวจสอบสำหรับรถทุกประเภทได้หรือไม่?',
        answer:
          'เราให้บริการตรวจสอบรถหลากหลายประเภท เช่น รถซีดาน รถ SUV และรถบรรทุก',
      },
      {
        question: 'ค่าใช้จ่ายสำหรับการตรวจสอบรถยนต์มือสองคือเท่าไร?',
        answer:
          'ค่าใช้จ่ายขึ้นอยู่กับแพ็กเกจที่เลือก คุณสามารถดูรายละเอียดราคาได้บนเว็บไซต์ของเรา',
      },
      {
        question: 'Wisedrive มีการรับประกันประเภทใดบ้าง?',
        answer:
          'เรามีแผนการรับประกันที่ครอบคลุมด้านการบำรุงรักษาและการซ่อมแซมรถหลากหลายรูปแบบ',
      },
      {
        question: 'ฉันสามารถซื้อการรับประกันพร้อมกับการตรวจสอบได้อย่างไร?',
        answer:
          'คุณสามารถเพิ่มแผนการรับประกันลงในแพ็กเกจการตรวจสอบของคุณระหว่างขั้นตอนการจองผ่านเว็บไซต์หรือแอปพลิเคชันของเรา',
      },
      {
        question: 'การรับประกันของ Wisedrive ครอบคลุมอะไรบ้าง?',
        answer:
          'การคุ้มครองขึ้นอยู่กับแผนที่เลือก แต่โดยทั่วไปแล้วจะครอบคลุมชิ้นส่วนสำคัญ เช่น เครื่องยนต์ ระบบเกียร์ และระบบไฟฟ้า',
      },
      {
        question: 'มีข้อยกเว้นใดบ้างในความคุ้มครองของการรับประกัน?',
        answer:
          'ใช่ มีข้อยกเว้นบางประการ โปรดดูรายละเอียดในเงื่อนไขและข้อตกลงของแผนการรับประกัน',
      },
      {
        question:
          'ฉันจะเคลมการซ่อมแซมภายใต้การรับประกันของ Wisedrive ได้อย่างไร?',
        answer:
          'ติดต่อทีมสนับสนุนของเราเพื่อยื่นคำร้อง และเราจะให้คำแนะนำตลอดกระบวนการ รวมถึงนำคุณไปยังศูนย์บริการที่ได้รับอนุญาต',
      },
      {
        question:
          'ฉันสามารถโอนการรับประกันให้เจ้าของใหม่ได้หรือไม่ หากฉันขายรถ?',
        answer:
          'ได้ คุณสามารถโอนการรับประกันไปยังเจ้าของใหม่ได้ เพื่อให้การคุ้มครองยังคงมีผลต่อไป',
      },
      {
        question: 'ระยะเวลาความคุ้มครองของการรับประกันคือเท่าไร?',
        answer:
          'ระยะเวลาการรับประกันขึ้นอยู่กับแพ็กเกจที่เลือก และสามารถครอบคลุมตั้งแต่ 6 เดือนจนถึงหลายปี',
      },
    ],
  },
  footerPage: {
    subTitle:
      'Wisedrive เป็นผู้ให้บริการตรวจสอบรถยนต์มือสองและการรับประกันรถยนต์มือสองรายแรกของอินเดีย โดยใช้ AI ขั้นสูงในอุตสาหกรรมการรับประกันยานยนต์ Wisedrive เป็นผู้นำในอุตสาหกรรมตรวจสอบรถยนต์มือสอง ด้วยการให้บริการใน 30 เมืองทั่วอินเดีย',
    footerLinkProducts: {
      header: 'Produk',
      links: [
        {
          link: '#inspection-plans',
          label: 'Inspeksi Mobil',
          type: 'anchor',
        },
        {
          link: '#inspection-plans',
          label: 'Garansi Mobil Bekas',
          type: 'anchor',
        },
        {
          link: '/',
          label: 'Servis & Perawatan Mobil',
          type: 'link',
        },
        {
          link: '/',
          label: 'Perbaikan & Perawatan Mobil',
          type: 'link',
        },
        {
          link: '#inspection-plans',
          label: 'Inspeksi Mobil Mewah',
          type: 'anchor',
        },
      ],
    },

    footerLinkCompany: {
      header: 'บริษัท',
      links: [
        {
          link: '/about-wisedrive',
          label: 'เกี่ยวกับเรา',
          type: 'link',
        },
        {
          link: '#how-it-works',
          label: 'วิธีการทำงาน?',
          type: 'anchor',
        },
        {
          link: '#contact-us',
          label: 'ติดต่อเรา',
          type: 'anchor',
        },
        {
          link: '/',
          label: 'เยี่ยมชมเรา',
          type: 'link',
        },
      ],
    },
    footerLinkResources: {
      header: 'แหล่งข้อมูล',
      links: [
        {
          link: '/',
          label: 'บล็อก',
          type: 'link',
        },
        {
          link: '/',
          label: 'โซเชียลมีเดีย',
          type: 'link',
        },
        {
          link: '/',
          label: 'จดหมายข่าว',
          type: 'link',
        },
        {
          link: '#contact-us',
          label: 'สนับสนุน',
          type: 'anchor',
        },
        {
          link: '#contact-us',
          label: 'ศูนย์ช่วยเหลือ',
          type: 'anchor',
        },
      ],
    },
    footerLinkPolicies: {
      header: 'นโยบายและข้อกำหนด',
      links: [
        {
          link: '/inspection-terms-and-conditions',
          label: 'ข้อกำหนดและเงื่อนไขการตรวจสอบ',
          type: 'link',
        },
        {
          link: '/warrantyPolicy',
          label: 'ข้อกำหนดและเงื่อนไขการรับประกัน',
          type: 'link',
        },
        {
          link: '/cancellation_refund_policy',
          label: 'นโยบายการยกเลิกและคืนเงิน',
          type: 'link',
        },
        {
          link: '/terms-and-conditions',
          label: 'นโยบายความเป็นส่วนตัว',
          type: 'link',
        },
        {
          link: '/privacy',
          label: 'นโยบายความเป็นส่วนตัว',
          type: 'link',
        },
      ],
    },
    footerCopyRight:
      '© WiseDrive Technologies (Thailand) Limited. All rights reserved 2025',
    footerCopyRightMobile: (
      <>
        © WiseDrive Technologies (Thailand) Limited. <br />
        All rights reserved 2025
      </>
    ),
  },
  aboutUsPage: {
    header: 'เกี่ยวกับเรา',
    leftHeader: (
      <>
        ภารกิจของเราคือ <br />
        รับประกัน
        <br /> ความสบายใจ <br />
        สำหรับผู้ซื้อรถมือสอง
      </>
    ),
    rightContent:
      'WiseDrive เป็นบริษัท Generative AI แห่งแรกในอินเดียที่ให้บริการตรวจสอบรถยนต์มือสองที่ล้ำสมัย และบริการรับประกันระดับโชว์รูมสำหรับรถยนต์มือสองในอินเดีย เราได้ร่วมมือกับศูนย์บริการที่ได้รับอนุญาตจาก OEM เพื่อมอบบริการที่ดีที่สุดให้กับลูกค้ารับประกันของเราหลังการซื้อ เพื่อให้มั่นใจถึงความสบายใจ เราให้บริการตรวจสอบโดยบุคคลที่สามที่เป็นอิสระและเป็นกลางด้วย AI ที่ดีที่สุดในอุตสาหกรรมยานยนต์ และรับประกันการตรวจสอบรถยนต์มือสองที่โปร่งใสและแม่นยำ',
    cardContent: [
      {
        header: '200,000+',
        description: 'การตรวจสอบรถมือสอง',
        subTitle: 'ลูกค้าที่ใช้บริการตรวจสอบของเรา',
      },
      {
        header: '75,000+',
        description: 'การรับประกันรถมือสอง',
        subTitle: 'ลูกค้ารับประกันที่ใช้งานอยู่ในอินเดีย',
      },
      {
        header: '8,000,000+',
        description: 'ความไว้วางใจใน WiseDrive',
        subTitle: 'กิโลเมตรที่ลูกค้าของเราเดินทางด้วยความพึงพอใจ',
      },
      {
        header: '20 เมือง',
        description: 'รหัสไปรษณีย์ 7000+',
        subTitle: 'เรามีบริการตรวจสอบใน 20 เมืองในอินเดีย',
      },
    ],
    headerDesc: 'ภารกิจของเรา',
    header2: 'เรารับประกันความสบายใจได้อย่างไร?',
    subTitle: 'เราเริ่มต้นด้วยการตรวจสอบรถของคุณก่อนที่คุณจะซื้อ',
    missionLeftContent:
      'WiseDrive มุ่งมั่นที่จะปกป้องผู้ซื้อรถยนต์มือสองจากความเสี่ยงในการซื้อรถที่ไม่น่าเชื่อถือ กระบวนการของเราเริ่มต้นด้วยการตรวจสอบอย่างละเอียดในแต่ละคัน เพื่อให้แน่ใจว่ารถผ่านมาตรฐานคุณภาพที่เข้มงวดของเรา เฉพาะรถยนต์ที่ผ่านการตรวจสอบเท่านั้นที่ได้รับตรารับรองจาก WiseDrive เพื่อเป็นส่วนหนึ่งของความมุ่งมั่นในการสร้างความพึงพอใจให้กับลูกค้า รถทุกคันที่ผ่านการอนุมัติจะได้รับการรับประกันฟรี 60 วัน การคุ้มครองเริ่มต้นนี้ทำให้ผู้ซื้อมีความมั่นใจและสบายใจในการซื้อของพวกเขา',
    missionLeftHeader: 'นี่คือวิธีการทำงาน:',
    missionLeftPoints: [
      'การตรวจสอบอย่างละเอียด: รถทุกคันได้รับการตรวจสอบอย่างเข้มงวดเพื่อระบุและแก้ไขปัญหาที่อาจเกิดขึ้น',
      'การรับประกันฟรี 60 วัน: รถที่ผ่านการอนุมัติจะได้รับการคุ้มครองนี้โดยไม่เสียค่าใช้จ่าย เพื่อให้ผู้ซื้อได้รับการป้องกันทันทีจากการซ่อมแซมที่ไม่คาดคิด',
      'ตัวเลือกขยายระยะเวลารับประกัน: หลังจาก 60 วันแรก ลูกค้าสามารถเลือกขยายการรับประกันและยังคงได้รับการคุ้มครองต่อไป',
    ],
    missionRightContent:
      'นอกเหนือจากการปกป้องในระหว่างการซื้อแล้ว โมดูลการบริการและการบำรุงรักษาของ WiseDrive ยังช่วยให้รถของคุณมีสุขภาพที่ดีในระยะยาว ผ่านแพลตฟอร์มของเรา ลูกค้าสามารถติดตามประวัติการบำรุงรักษารถของพวกเขา รับการแจ้งเตือนเกี่ยวกับการบำรุงรักษาที่จะมาถึง และจองนัดหมายกับศูนย์บริการที่เชื่อถือได้',
    missionRightHeader: 'คุณสมบัติการบำรุงรักษาของเราประกอบด้วย:',
    missionRightPoints: [
      'การแจ้งเตือนบริการ: ไม่พลาดงานบำรุงรักษาที่สำคัญ เช่น การเปลี่ยนถ่ายน้ำมันเครื่อง การสลับยาง หรือการตรวจสอบเบรก',
      'การจองที่ง่ายดาย: นัดหมายบริการผ่านแพลตฟอร์มของเราโดยตรงกับศูนย์บริการที่ได้รับการตรวจสอบแล้ว',
      'การติดตามประวัติการบำรุงรักษา: เก็บบันทึกทั้งหมดไว้ในที่เดียวเพื่อการจัดการที่ดียิ่งขึ้นและเพิ่มมูลค่าขายต่อของรถ',
    ],
    missionRightFooter:
      'ด้วยการรวมการตรวจสอบอย่างละเอียด การคุ้มครองการรับประกัน และการสนับสนุนการบำรุงรักษาอย่างต่อเนื่อง WiseDrive ไม่เพียงช่วยให้ผู้ซื้อหลีกเลี่ยงรถที่มีปัญหา แต่ยังช่วยให้รถของพวกเขาอยู่ในสภาพที่ดีที่สุด ปลอดภัยและเชื่อถือได้ในระยะยาว',
  },
  termsPage: {
    header: 'ข้อกำหนดและเงื่อนไข',
    contentArray: [
      {
        data: (
          <>
            <strong>"เรา/พวกเรา" และ "เรา" </strong>
            หมายถึง WiseDrive Technologies (Thailand) Limited
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ข้อตกลง" </strong>หมายถึงข้อตกลงระหว่าง Wisedrive และลูกค้า
            ซึ่ง Wisedrive
            ตกลงจัดให้มีผู้ตรวจสอบทำการตรวจสอบตามข้อกำหนดและเงื่อนไขนี้
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ค่าธรรมเนียมการยกเลิก" </strong>
            หมายถึงจำนวนเงินที่ลูกค้าต้องชำระตามที่ระบุไว้ในข้อกำหนดและเงื่อนไขนี้
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ลูกค้า/คุณ" </strong>หมายถึงลูกค้าของ Wisedrive
            ที่สั่งซื้อตรวจสอบ
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ค่าธรรมเนียม" </strong>หมายถึงจำนวนเงินที่ลูกค้าต้องชำระให้
            Wisedrive สำหรับการตรวจสอบ ตามที่ระบุไว้ที่
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"การตรวจสอบ" </strong>
            หมายถึงการตรวจสอบภายนอกของยานพาหนะผ่านสื่อเสียงและภาพ
            รวมถึงการทดสอบการขับขี่ที่ดำเนินการโดยผู้ตรวจสอบในนามของ Wisedrive
            สำหรับลูกค้าตามข้อกำหนดและเงื่อนไขนี้
          </>
        ),
      },
      {
        data: (
          <>
            Wisedrive มีประเภทการตรวจสอบที่แตกต่างกัน
            ซึ่งแต่ละประเภทประกอบด้วยการตรวจสอบที่ต่างกัน
            รายละเอียดของประเภทการตรวจสอบและรายการตรวจสอบสามารถดูได้ที่
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
            หรือโทร +66 81 899 4420
            การยืนยันประเภทของการตรวจสอบที่ลูกค้าเลือกให้ดำเนินการกับยานพาหนะ
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ผู้ตรวจสอบ" </strong>
            หมายถึงผู้ตรวจสอบที่มีคุณสมบัติเหมาะสมซึ่งดำเนินการตรวจสอบในนามของ
            Wisedrive โดยขึ้นอยู่กับความพร้อมให้บริการ
            และอาจรวมถึงตัวแทนภายนอกที่เหมาะสม
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"รายงาน" </strong>
            หมายถึงรายงานที่เป็นลายลักษณ์อักษรที่ผู้ตรวจสอบจัดทำขึ้นระหว่างการตรวจสอบ
            ซึ่งรวมถึงชื่อและที่อยู่ของลูกค้า
            รายละเอียดการลงทะเบียนของยานพาหนะที่ตรวจสอบ
            ตำแหน่งที่ตั้งของยานพาหนะ ผลการตรวจสอบ (ผ่านหรือไม่ผ่าน)
            รายการตรวจสอบที่ดำเนินการ
            (ขึ้นอยู่กับประเภทของการตรวจสอบที่ลูกค้าต้องการ)
            และข้อกังวลที่ผู้ตรวจสอบเห็นว่าควรแจ้งให้ลูกค้าทราบ
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"รายการตรวจสอบรายงาน" </strong>
            หมายถึงรายการที่ผู้ตรวจสอบได้ตรวจสอบในระหว่างการตรวจสอบทางกายภาพ
            ซึ่งสามารถดูได้ที่
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ยานพาหนะ" </strong>
            หมายถึงยานพาหนะที่ลูกค้าต้องการให้ผู้ตรวจสอบดำเนินการตรวจสอบ
          </>
        ),
      },
    ],
    subHeader3: (
      <>
        <strong>การทดสอบขับขี่</strong>
      </>
    ),
    listContent2: [
      <>
        เพื่อให้ผู้ตรวจสอบของเราสามารถดำเนินการทดสอบขับขี่บนรถยนต์ของคุณได้
        คุณต้องตรวจสอบให้แน่ใจว่ารถมี:
        <br /> (a) น้ำเพียงพอ; <br /> (b) น้ำมันเครื่องเพียงพอ;
        <br /> (c) น้ำมันเชื้อเพลิงเพียงพอ
      </>,
      'การทดสอบขับขี่จะดำเนินการภายในพื้นที่ใกล้เคียงกับจุดตรวจสอบ หาก:',
      'รถยนต์อยู่ในสภาพที่ไม่พร้อมใช้งานบนท้องถนน หรือมีน้ำมันเครื่อง น้ำ หรือ น้ำมันเชื้อเพลิงไม่เพียงพอ',
      'ลูกค้าไม่สามารถยืนยันได้ว่ารถมีใบรับรองความปลอดภัยที่ถูกต้อง และทำให้ไม่สามารถดำเนินการทดสอบขับขี่ได้ในระหว่างการตรวจสอบ',
      'ค่าธรรมเนียมสำหรับการตรวจสอบจะต้องชำระเต็มจำนวน และจะมีค่าธรรมเนียมเพิ่มเติมหากคุณต้องการให้เราดำเนินการทดสอบขับขี่ในภายหลัง',
      'การดำเนินการทดสอบขับขี่ไม่ได้หมายความว่าผู้ตรวจสอบของเราได้เห็นใบรับรองความปลอดภัยที่ถูกต้อง',
      'การขออนุญาตที่จำเป็นและการเข้าถึงรถยนต์เป็นความรับผิดชอบของลูกค้า ลูกค้าต้องตรวจสอบให้แน่ใจว่ามีการจัดเตรียมพื้นที่ที่เหมาะสม (รวมถึงการได้รับอนุญาตจากเจ้าของรถยนต์) เพื่อให้การตรวจสอบสามารถดำเนินการในอู่ซ่อมรถหรือบริเวณที่มีพื้นที่แข็งแรง แห้ง และราบเรียบ',
      'ผู้ตรวจสอบของเราต้องการพื้นที่เพียงพอในการเดินรอบรถและเปิดประตูทุกบานได้อย่างเต็มที่ รวมถึงต้องมีที่จอดรถสำหรับรถของผู้ตรวจสอบใกล้กับจุดตรวจสอบ',
      'ต้องมีแสงสว่างที่เหมาะสม เช่น แสงในร่มที่มีคุณภาพดี หรือแสงแดดหากรถจอดอยู่นอกอาคาร เราไม่สามารถตรวจสอบรถในที่แสงน้อยหรือมืดได้',
    ],

    subHeader4: 'ค่าธรรมเนียมและการยกเลิก',
    listContent3: [
      'ค่าธรรมเนียมจะต้องชำระในขณะที่ทำการจองการตรวจสอบ',
      <>
        เราขอสงวนสิทธิ์ในการปฏิเสธการตรวจสอบหรือออกใบรายงานสำหรับรถยนต์ที่:
        <br /> (a) ผู้ตรวจสอบไม่สามารถเข้าถึงได้อย่างเหมาะสม; หรือ
        <br /> (b) มีลักษณะที่ไม่ได้มาจากการผลิตมาตรฐาน (เช่น รถประกอบเอง);
        <br /> (c) มีการดัดแปลงหรือไม่ได้ถูกใช้งานเป็นประจำ (เช่น
        มีร่องรอยการกัดกร่อนจากการจอดทิ้งไว้นาน
        และอาจทำให้รถไม่ปลอดภัยต่อการขับขี่);
        <br /> (d) ไม่พร้อมใช้งานบนท้องถนนหรือไม่ปลอดภัยต่อการขับขี่
      </>,
      'กรณีที่กล่าวถึงในข้อกำหนดและเงื่อนไขเหล่านี้',
      'หากลูกค้าไม่ได้จัดเตรียมสถานที่ที่เหมาะสมสำหรับการตรวจสอบตามที่กำหนด',
      'หากลูกค้าให้ข้อมูลที่ไม่ถูกต้องหรือไม่ครบถ้วน ทำให้เราไม่สามารถดำเนินการตรวจสอบได้ ลูกค้ารับทราบว่าในกรณีดังกล่าว เรามีสิทธิ์ยุติสัญญาและเก็บค่าธรรมเนียมทั้งหมด หากลูกค้าต้องการให้เราดำเนินการตรวจสอบใหม่ จะต้องชำระค่าธรรมเนียมใหม่ในขณะที่ทำการจอง',
      'ลูกค้ามีสิทธิ์ยกเลิกการตรวจสอบและขอรับเงินคืนเต็มจำนวนได้ หากแจ้งยกเลิกก่อนเวลานัดตรวจสอบ 24 ชั่วโมง หลังจากที่การตรวจสอบดำเนินการแล้ว จะไม่มีการคืนเงิน',
      'หากต้องการยกเลิกการตรวจสอบ ลูกค้าต้องแจ้งทีมสนับสนุนของเราทางอีเมลที่ support.th@wisedrive.com หรือโทร +66 81 899 4420 ในวันจันทร์ถึงศุกร์ เวลา 9:00 น. - 17:00 น. กรุณาให้ข้อมูลชื่อ ที่อยู่ เบอร์โทรศัพท์ และหมายเลขการจองของคุณ (ตามที่ระบุในอีเมลยืนยันการจอง) พร้อมคำขอยกเลิกของคุณ',
    ],
    subHeader5: 'การร้องเรียน',
    listContent4: [
      'หากคุณมีข้อร้องเรียนหรือไม่พอใจกับการตรวจสอบที่ดำเนินการ กรุณาติดต่อเราที่ +66 81 899 4420 โดยเร็วที่สุด เราอาจต้องตรวจสอบรถยนต์อีกครั้งเพื่อจัดการกับข้อร้องเรียน และคุณตกลงที่จะอนุญาตให้เราทำเช่นนั้น',
      'ห้ามซ่อมแซมหรือเปลี่ยนอะไหล่ใด ๆ ในรถยนต์ที่เป็นหัวข้อของข้อร้องเรียนก่อนที่เราจะได้ทำการตรวจสอบซ้ำ หากจำเป็นต้องมีการซ่อมแซมฉุกเฉินเพื่อให้รถอยู่ในสภาพปลอดภัย และต่อมาจะมีการร้องเรียนเกี่ยวกับรถ คุณต้องแจ้งให้เราทราบถึงข้อร้องเรียน (รวมถึงการแจ้งเกี่ยวกับความจำเป็นในการซ่อมแซมฉุกเฉิน) ภายในระยะเวลาที่เหมาะสมหลังจากพบปัญหา และต้องเก็บอะไหล่ที่เสียหายหรือถูกเปลี่ยนไว้เพื่อให้เราตรวจสอบในภายหลัง เราจะไม่รับผิดชอบต่อค่าใช้จ่ายในการซ่อมแซมหรือเปลี่ยนอะไหล่ที่ดำเนินการไปโดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากเราก่อน',
      'เราขอสงวนสิทธิ์ในการให้ผู้ตรวจสอบของเราตรวจสอบรถอีกครั้งโดยไม่มีค่าใช้จ่ายเพิ่มเติม หากเราพิจารณาแล้วว่าเป็นสิ่งจำเป็นในการจัดการข้อร้องเรียน และคุณต้องอนุญาตให้ผู้ตรวจสอบของเราทำการตรวจสอบซ้ำตามข้อกำหนดและเงื่อนไขเหล่านี้ เราจะให้ความเห็นที่เป็นกลางเพิ่มเติมเกี่ยวกับรายงานฉบับแรกที่ออกให้',
    ],

    subHeader6: 'เหตุการณ์ที่อยู่นอกเหนือการควบคุมของเรา',
    listContent5: [
      'เราจะไม่รับผิดชอบต่อความล่าช้าหรือการไม่สามารถดำเนินการตรวจสอบได้อันเนื่องมาจากเหตุการณ์หรือสถานการณ์ที่อยู่นอกเหนือการควบคุมของเรา เราจะพยายามลดผลกระทบจากสถานการณ์ดังกล่าวให้มากที่สุดเท่าที่จะเป็นไปได้',
      'Wisedrive จะรับผิดชอบต่อลูกค้า (แต่ไม่ใช่บุคคลอื่น) ในขอบเขตที่ Wisedrive ไม่สามารถดำเนินการตรวจสอบตามข้อกำหนดและเงื่อนไขเหล่านี้ได้ โดยไม่จำกัดข้อกำหนดดังกล่าว คุณรับทราบว่า Wisedrive หรือผู้ตรวจสอบจะไม่รับผิดชอบต่อคุณหรือบุคคลอื่นสำหรับความรับผิด ความสูญเสีย ความเสียหาย ข้อเรียกร้อง การดำเนินคดี ค่าใช้จ่าย หรือค่าใช้จ่ายอื่น ๆ (รวมเรียกว่า "ความสูญเสีย") ที่เกิดขึ้นในสถานการณ์ต่อไปนี้:',
      'ความสูญเสียดังกล่าวไม่ใช่ผลลัพธ์ที่สามารถคาดการณ์ได้อย่างสมเหตุสมผลจากการละเมิดเงื่อนไข (สามารถคาดการณ์ได้หากคุณและเราคาดไว้ในขณะที่ทำการตรวจสอบรถ)',
      'ความสูญเสียดังกล่าวไม่ได้เกิดขึ้นโดยตรงจากการละเมิดเงื่อนไขของเราหรือผู้ตรวจสอบ',
      'ความสูญเสียดังกล่าวเกี่ยวข้องกับธุรกิจหรือความเสียหายอื่น ๆ ที่เกี่ยวข้องกับลูกค้าที่ไม่ใช่ผู้บริโภค',
      'ความสูญเสียดังกล่าวเพิ่มขึ้นเนื่องจากการละเมิดเงื่อนไขของคุณในข้อตกลงนี้',
      'ไม่มีสิ่งใดในที่นี้จะมีผลกระทบต่อสิทธิ์ตามกฎหมายของผู้บริโภคภายใต้กฎหมายที่เกี่ยวข้อง',
    ],

    subHeader7: 'การบังคับใช้เงื่อนไข',
    listContent6: [
      'เงื่อนไขแต่ละข้อของข้อตกลงนี้มีผลบังคับใช้แยกกัน หากศาลหรือหน่วยงานที่เกี่ยวข้องตัดสินว่าเงื่อนไขใด ๆ ไม่ชอบด้วยกฎหมาย เงื่อนไขอื่น ๆ ยังคงมีผลบังคับใช้อย่างสมบูรณ์',
      'ข้อตกลงนี้เป็นระหว่างคุณและ Wisedrive ไม่มีบุคคลอื่นใดที่มีสิทธิ์ในการบังคับใช้เงื่อนไขของข้อตกลงนี้ และไม่มีฝ่ายใดจำเป็นต้องได้รับความยินยอมจากบุคคลอื่นเพื่อทำการเปลี่ยนแปลงเงื่อนไขเหล่านี้',
    ],

    subHeader8: 'คำแนะนำเกี่ยวกับรายงาน',
    listContent7: [
      'เราแนะนำให้คุณพูดคุยเกี่ยวกับผลการตรวจสอบในรายงานกับผู้ขายก่อนตัดสินใจซื้อรถ หากคุณยังไม่ได้ดูรถด้วยตนเอง คุณต้องตรวจสอบให้แน่ใจว่าลักษณะภายนอกและสเปกของรถตรงกับความต้องการและความคาดหวังของคุณ เราขอแนะนำให้คุณดูและทดลองขับรถด้วยตนเองก่อนตัดสินใจซื้อ',
    ],
  },
  warrantyTerms: {
    header: 'ข้อยกเว้นการรับประกันและข้อกำหนดและเงื่อนไข',
    subHeader1: 'คำอธิบายการรับประกัน',
    point:
      'บริการรวมและ/หรือการซ่อมรวมจะดำเนินการตามที่ระบุในรายละเอียดแผน ลูกค้าได้เลือกซื้อแพ็กเกจบริการรวม/ซ่อมรวมโดยสมัครใจ ซึ่งเป็นผลิตภัณฑ์ที่มีมูลค่าเพิ่มเติมที่นำเสนอโดย WiseDrive Technologies (Thailand) Limited สำหรับการใช้งานส่วนบุคคลเท่านั้น การใช้สิทธิประโยชน์เพิ่มเติมโดยการจ่ายค่าใช้จ่ายเพิ่มเติมขึ้นอยู่กับดุลยพินิจของลูกค้า ดังนั้น WiseDrive Technologies (Thailand) Limited ตั้งใจจะขายแผนการบำรุงรักษาบริการให้กับลูกค้าผ่านตัวแทนจำหน่ายรถยนต์มือสองที่ได้รับอนุญาตและทางออนไลน์ผ่าน www.wisedrive.com ในประเทศอินเดีย โดยขึ้นอยู่กับข้อกำหนดและเงื่อนไขที่ระบุไว้ด้านล่าง ลูกค้าจึงยืนยันว่าเขาได้เข้าใจและยอมรับข้อกำหนดดังกล่าวทั้งหมดแล้ว บริการและการซ่อมรวมจะใช้ได้เฉพาะกับสเปคผลิตภัณฑ์ที่สร้างจากโรงงานเดิมเท่านั้น',
    subHeader2: 'ระยะเวลาของการครอบคลุมแพ็กเกจ (สำหรับทุกแพ็กเกจ):',
    durationList: [
      'แพ็กเกจจะเริ่มต้นจากวันที่เริ่มต้นการรับประกันของรถยนต์ตามวันที่เปิดใช้งานแพ็กเกจ',
      'ค่าใช้จ่ายสำหรับบริการและการซ่อมที่ทำก่อนการซื้อแพ็กเกจจะไม่ครอบคลุมหรือไม่สามารถขอคืนได้',
      'แพ็กเกจจะสิ้นสุดเมื่อถึงเกณฑ์เวลาที่กำหนด ซึ่งจะมีอายุ 6 เดือน (180 วัน) หรือ 12 เดือน (365 วัน) หรือเมื่อรถยนต์มีระยะทางถึง 10,000 กิโลเมตร (แล้วแต่กรณีใดจะเกิดขึ้นก่อน) ขึ้นอยู่กับแพ็กเกจที่ลูกค้าสมัคร',
      'หากรถได้รับการอนุมัติภายใต้ระยะเวลาการเย็น เงื่อนไขของระยะเวลาการเย็นที่ระบุใน KMS & วันต้องเสร็จสิ้นก่อนที่ลูกค้าจะสามารถขอเรียกร้องการรับประกันได้',
    ],

    subHead3: 'ข้อยกเว้น',
    subtitleExclusions: "(บริการต่อไปนี้ไม่ได้รวมอยู่ใน 'การซ่อมรวม')",
    exclusionsList: [
      'น้ำมันและมลพิษในระบบน้ำมันและความเสียหายที่เกิดจากความเสียหายที่พื้นผิวสี, ตัวถัง, ฝาครอบ, และแผง.',
      'ข้อบกพร่องของกระจกทุกประเภทและ/หรือความเสียหายจากอุบัติเหตุ (เช่น กระจกมองข้าง, หน้าต่าง, โครงไฟหน้า, การบิดเบือนแสง, จุด, ภาพเบลอ, ฯลฯ).',
      'ยาง, น้ำหนักสมดุลล้อ, และความเสียหายของล้อ.',
      'การซ่อมแซมที่ผู้ใช้รถยนต์ต้องรับผิดชอบ (ความเสียหายของเครื่องยนต์จากการขาดน้ำมัน, การเปลี่ยนถ่ายน้ำมันล่าช้า, และการเข้าร่วมในการแข่งขันรถ).',
      'การล็อคไฮโดรสแตติก, น้ำท่วมและ/หรือความเสียหายจากอุบัติเหตุ.',
      'การล็อคไฮโดรสแตติก, น้ำท่วมและ/หรือความเสียหายจากอุบัติเหตุ.',
      'หลอดไฟ, ฯลฯ (ยกเว้นไฟ LED และ Xenon).',
      'กลิ่นและข้อบกพร่องที่เกี่ยวข้องกับการสะสมฝุ่น เช่น หัวฉีดระบบล้างที่ปัดน้ำฝน, ฯลฯ.',
      'การซ่อมแซมหรือผลที่เกิดจากการใช้ของแต่งของแท้/ไม่แท้.',
      'ความเสียหายจากอุบัติเหตุและความเสียหายทั่วไปที่เกิดจากแรงภายนอก, การชน, น้ำท่วม, การกัดกร่อน, ไฟ, การขโมย, การกัดของหนู, หรือความเสียหายที่เกิดจากปัจจัยภายนอกและไม่ได้เกี่ยวข้องกับข้อบกพร่องในการผลิตไม่ได้รับการคุ้มครองภายใต้แผนการบำรุงรักษาล่วงหน้าของ Wisedrive.',
      'การปรับแต่งทั้งหมด เช่น การจัดตำแหน่งล้อ, การปรับสมดุล, การจัดตำแหน่งไฟหน้า, ฯลฯ ไม่ครอบคลุมในแผนการบำรุงรักษาล่วงหน้าของ Wisedrive.',
      'ข้อกังวลเกี่ยวกับตัวถังและพื้นผิวสีไม่ได้รับการคุ้มครองในแผนการบำรุงรักษาล่วงหน้าของ Wisedrive. ชิ้นส่วนที่เกี่ยวข้องกับการบำรุงรักษาตามกำหนด เช่น น้ำมันหล่อลื่น, กรอง, น้ำมันเบรค, น้ำมันพวงมาลัย, สายพานขับ, หัวเทียน, น้ำหล่อเย็น, ที่ปัดน้ำฝน, ฯลฯ ตามที่ใช้.',
      'วัสดุที่ใช้หมด เช่น น้ำยาล้างเบรค, จาระบี, ก๊าซแอร์, สารเติมแต่ง, ฟิวส์, และรีเลย์. ระบบท่อไอเสียทั้งหมด เช่น ท่อเก็บเสียง, มัฟฟ์เลอร์, ตัวกรองคาร์บอน, และตัวกรองอนุภาคดีเซล.',
      'แบตเตอรี่ทั้งหมด เช่น แบตเตอรี่สตาร์ท, แบตเตอรี่อะไหล่, และแบตเตอรี่รีโมต.',
      'ชิ้นส่วนไฟทั้งหมดรวมถึงไฟหน้า, ไฟท้าย, และไฟตัดหมอก.',
      'ชิ้นส่วนที่สึกหรอทุกประเภท เช่น ล้อ, ผ้าเบรคและจานเบรค, แผ่นคลัทช์, ชิ้นส่วนยางที่เกี่ยวข้องกับระบบช่วงล่าง เช่น บูช, ตัวดูดซับแรงสะเทือน, ตัวดูดซับแรงสะเทือนของบูท, เสาอากาศแบบอากาศ, บอลลูนอากาศ, รางซันรูฟ, คู่มือซันรูฟ, สายพาน, ชิ้นส่วนพลาสติกและยาง.',
      'การติดตั้งยางทั้งหมด เช่น การติดตั้งเครื่องยนต์, การติดตั้งเกียร์, และการติดตั้งท่อไอเสีย.',
      'ค่าใช้จ่ายในการวินิจฉัย, การตรวจสอบ/ทดสอบ, การอัปเดตซอฟต์แวร์, และการปรับแต่ง.',
      'อุปกรณ์เสริมทั้งหมดและชิ้นส่วนที่ติดตั้งภายนอก เช่น ระบบความบันเทิง, และชุดเสริม.',
      'รีโมทมัลติมีเดีย, รีโมทล็อกกลาง, แผงควบคุม, คอนโซลกลาง, ที่วางแขน, นาฬิกา, การตกแต่งเพดาน, ผ้าม่านซันรูฟ, พรมปูพื้น, การดูดเสียงและความร้อน.',
      'ความเสียหายจากภายนอกทั้งหมดที่เกิดจากการซึมน้ำ/การรั่วไหลไปยังชิ้นส่วนไฟฟ้าและไม่ใช่ไฟฟ้า.',
      'ความล้มเหลวทั้งหมดที่รายงานจากความล่าช้าหรือความผิดพลาดในการดำเนินการบำรุงรักษาตามกำหนด/การซ่อมแซมที่ตัวแทนจำหน่ายที่ได้รับอนุญาต.',
      'ความเสียหายหรือความล้มเหลวทั้งหมดที่เกิดจากการติดตั้ง/การใช้งานชิ้นส่วนอะไหล่ที่ไม่แท้, น้ำมันหล่อลื่น, หรืออุปกรณ์เสริม.',
      'ความล้มเหลวทั้งหมดที่รายงานจากการใช้เชื้อเพลิงที่เจือปนหรือผิดประเภท.',
      'ข้อบกพร่องที่มีอยู่ก่อนที่พบ/บันทึกระหว่างการประเมินหรือที่รายงานก่อนการออกนโยบายจนกว่าจะได้รับการแก้ไขโดยตัวแทนจำหน่ายที่ได้รับอนุญาต.',
      'การเรียกร้องทั้งหมดที่รายงานเกี่ยวกับรถยนต์ที่ได้รับการประกาศเป็นการสูญเสียทั้งหมดจากการประกันภัยหรือหน่วยงานที่มีอำนาจและจากนั้นได้รับการซ่อมแซม.',
      'ความล้มเหลวทั้งหมดและความล้มเหลวที่ตามมาที่รายงานจากการใช้รถอย่างต่อเนื่องแม้ว่าจะได้รับรหัสข้อผิดพลาดหรือความล้มเหลวในการระบุปัญหาของรถ.',
      'แพ็กเกจการรับประกันของ Wisedrive ไม่รวมถึงการชดเชยใดๆ สำหรับการซ่อมแซมหรือการเปลี่ยนแปลงภายนอกที่คุณทำหรือความเสียหายจากอุบัติเหตุใดๆ.',
    ],
    subHead4: 'การรับประกันนี้จะไม่ครอบคลุมถึง:',
    warrantNotApplyList: [
      'บริการบำรุงรักษาปกติ เช่น การทำความสะอาดและขัดเงา, การทำความสะอาดหัวฉีด, การทำความสะอาดเครื่องยนต์, การปรับแต่งเครื่องยนต์, การเปลี่ยนถ่ายน้ำมัน/ของเหลว, การเติมน้ำมันกรอง, การขันสกรู, การปรับประตู, การปรับเบรคและคลัทช์, การปรับสมดุลล้อ, การจัดตำแหน่งล้อ, การหมุนยาง, การปรับไฟหน้า.',
      'การเปลี่ยนชิ้นส่วนที่เกิดจากการสึกหรอตามปกติ เช่น หัวเทียน, สายพาน, ผ้าเบรค, รองเท้าเบรค, จานเบรค, จาน/แผ่นคลัทช์, กรอง, ใบปัดน้ำฝน, หลอดไฟ, ฟิวส์, แปรง, ท่อยาง, ยาง/ท่อ, แบตเตอรี่, ระบบเสียง, ระบบเสียงและวิดีโอการนำทาง (AVN), ตัวกรองคาร์บอน, ท่อเก็บเสียง/ท่อไอเสีย.',
      'ปลอกคอลูกยาง, ปลอกจานลูกยาง, ดรัมเบรคหลัง, และลูกปืนล้อหน้าและหลัง ไม่ได้รับการคุ้มครองเกิน 60,000 กม.',
      "ชิ้นส่วนยาง เช่น ชุดกระบอกล้อ, ซีลยางทุกประตู, แหวน 'O' ของแอร์, สายคลัทช์, สายเคเบิลเร่ง, สายเคเบิลไมล์ และสายเปิดประตูท้าย.",
      'การรั่วไหลของน้ำยาแอร์.',
      'การสึกหรอจากอายุการใช้งาน, การเสื่อมสภาพ หรือการเป็นสนิมของชิ้นส่วนที่ชุบ, สีทา, ชิ้นส่วนยาง, สิ่งทอ, ชิ้นส่วนตกแต่งอ่อน, ฯลฯ.',
      'ตัวถัง, สี, กระจก, การตกแต่งภายใน/ภายนอก, ระบบท่อไอเสีย, และการสึกหรอปกติของชิ้นส่วนอื่นๆ.',
      'นโยบายของ Wisedrive มีระยะเวลาคูลลิ่งเริ่มต้น 10 วัน; การเรียกร้องใดๆ ที่ลงทะเบียนภายในระยะเวลานี้จะไม่ได้รับการคุ้มครองหรืออนุมัติ.',
      'หากรุ่นรถมีชุด LPG/CNG (ไม่ว่าจะติดตั้งจากโรงงานหรือจากการติดตั้งในท้องถิ่น) จะไม่ได้รับการคุ้มครองภายใต้การรับประกันขยายของ Wisedrive.',
    ],
    subtitle5: 'ความเสียหายหรือความล้มเหลวที่เกิดจาก:',
    DamageFailureList: [
      'การรับประกันจะเป็นโมฆะและจะไม่สามารถนำกลับมาใช้ใหม่ได้หากรถยนต์ไม่ได้รับการบริการในเวลาที่เหมาะสมโดยลูกค้า ซึ่ง: การบริการทั่วไปครั้งที่ 1*- ต้องทำภายใน 3 เดือนหรือไม่เกิน 3,000 กม. นับจากวันที่เปิดใช้งานแพ็กเกจการรับประกัน (แล้วแต่กรณีที่เกิดขึ้นก่อน).',
      'การใช้รถผิดวิธี, การทำร้าย (เช่น การแข่งรถ, การบรรทุกเกิน, การขับขี่ผ่านคลัทช์), อุบัติเหตุหรือการชน, การโจรกรรม, น้ำท่วม, หรือไฟไหม้.',
      'การใช้น้ำมัน, ของเหลว, หรือจาระบีที่ไม่เหมาะสม, ปนเปื้อน, หรือไม่เพียงพอ.',
      'การใช้ชิ้นส่วนที่ไม่ใช่ชิ้นส่วนของผู้ผลิต (OEM) ที่แท้จริง.',
      'อุปกรณ์และ/หรืออุปกรณ์เสริมที่ไม่ได้จัดหาโดย Wisedrive หรือไม่ได้รับการอนุมัติจาก Wisedrive.',
      'การปรับแต่ง, การเปลี่ยนแปลง, การดัดแปลง, หรือการซ่อมแซมที่ไม่เหมาะสม.',
      'การใช้ชิ้นส่วนในงานที่ไม่ได้ออกแบบหรือไม่ได้รับการอนุมัติจาก Wisedrive.',
      'การซ่อมแซมใด ๆ ที่ไม่ได้ทำโดยตัวแทนจำหน่าย/ศูนย์บริการที่ได้รับอนุญาตจาก Wisedrive.',
      'ความผิดปกติเล็กน้อยที่ไม่ได้รับการพิจารณาว่ามีผลกระทบต่อคุณภาพหรือการทำงานของรถยนต์หรือชิ้นส่วน เช่น เสียงหรือการสั่นสะเทือนเล็กน้อย, หรือสิ่งที่ถือเป็นลักษณะของรถยนต์.',
      'การตกตะกอนจากอากาศ, การตกตะกอนจากอุตสาหกรรม, ฝนกรด, น้ำท่วม, ลูกเห็บ, พายุลม, หรือภัยพิบัติธรรมชาติอื่นๆ.',
      'รอยขีดข่วนบนสี, รอยบุบ, หรือความเสียหายที่คล้ายกันที่เกิดจากสีหรือตัวถัง.',
      'การปฏิวัติหรือการกบฏ, การกระทำโดยเจตนาหรือการกระทำที่ได้รับการปรับเปลี่ยนจากเจ้าของหรือผู้ขับขี่, การทารุณกรรมรถยนต์, การประมาท.',
      'การกระทำขององค์ประกอบถนน (ทราย, กรวด, ฝุ่น, หรือเศษวัสดุบนถนน) ที่ทำให้สี/กระจกเกิดรอยขีดข่วนหรือทำให้ชิ้นส่วนอื่น ๆ เสียหาย.',
      'รถยนต์ที่ถูกใช้ในกิจกรรมการแข่งขัน, กีฬา, การชุมนุม, การขนส่งเพื่อการให้เช่า, บริการแท็กซี่หรือการให้เช่าขับขี่เองระยะสั้นหรือระยะยาว, หรือการใช้ในเชิงพาณิชย์ใด ๆ.',
      'รถยนต์ที่ซื้อมาเป็นแท็กซี่ภายใต้การยกเว้นภาษีพิเศษหรือจดทะเบียนเป็นแท็กซี่ท่องเที่ยวกับหน่วยงานการขนส่ง.',
      'รถยนต์ที่มีการดัดแปลงมิเตอร์ระยะทาง, เปลี่ยนแปลง, หรือถอดออก.',
      'ความเสียหายที่เกิดจากอุบัติเหตุหรือการเสี่ยงบนถนน, รวมถึงแต่ไม่จำกัดเพียงการสูญเสียเวลา, ความไม่สะดวก, การสูญเสียการใช้งานของรถยนต์, หรือการสูญเสียเชิงพาณิชย์.',
      'จะไม่มีการรับผิดชอบในความสูญเสียใด ๆ ที่ครอบคลุมภายใต้กรมธรรม์ความเสียหายจากอุบัติเหตุหรือความเสี่ยงจากถนน หรือความเสียหายจากอุบัติเหตุ/ไฟไหม้บนถนน, ไม่มีการรับผิดชอบในความเสียหายใด ๆ ต่อบุคคลที่สาม.',
      'จะไม่มีการรับผิดชอบในความเสียหายที่เกิดจากความประมาท, การแทรกซึมของสิ่งแปลกปลอมที่เป็นอันตรายหรือเป็นอันตราย, การขาดการบริการ, การร้อนเกินไป, การแช่แข็ง, หรือการทารุณกรรมในการใช้งานต่อเนื่องของรถยนต์หลังจากที่ปัญหาได้รับการชี้แจงแล้ว หรือการสูญเสียที่ตามมาจากการล้มเหลวของชิ้นส่วนที่ไม่ได้รับการคุ้มครองภายใต้การรับประกันขยายนี้.',
    ],
    subHead6: 'ข้อกำหนดอื่น ๆ:',
    otherTermsList: [
      'แพ็กเกจบริการรวมและ/หรือการซ่อมรวมมีให้สำหรับรถยนต์มือสอง* ทุกรุ่น (ยกเว้นรถยนต์หรู) ที่ขายในอินเดีย.',
      'ลูกค้าต้องสั่งซื้อบริการและ/หรือการซ่อมรวมผ่านแอป Wisedrive ในส่วนแผนของฉัน หรือผ่านการสนับสนุนลูกค้าที่ +91 +66 81 899 4420.',
      'งานบริการและบำรุงรักษาทั้งหมดต้องดำเนินการที่ศูนย์บริการที่ได้รับอนุญาตจาก Wisedrive หรือโดยช่างเทคนิคที่ได้รับการอนุมัติจาก Wisedrive.',
      'บริการรวมและ/หรือการซ่อมรวมสามารถโอนให้เจ้าของคนถัดไปหลังจากการอนุมัติการตรวจสอบ แต่ไม่สามารถโอนให้รถยนต์คันอื่นได้ด้วยค่าธรรมเนียม.',
      'ลูกค้าสามารถขอการยกเลิกแพ็กเกจบริการรวมและ/หรือการซ่อมรวมภายในสองสัปดาห์จากวันที่เปิดใช้งานแพ็กเกจโดยไม่ใช้บริการใด ๆ กับรถยนต์ภายใต้ขอบเขตใด ๆ. จะไม่มีการยกเลิกหรือคืนเงินหลังจากระยะเวลาที่กล่าวถึงข้างต้น.',
      'หากรถยนต์ที่ครอบคลุมภายใต้บริการรวมและ/หรือการซ่อมรวมมีส่วนเกี่ยวข้องกับอุบัติเหตุที่ทำให้ไม่สามารถซ่อมแซมได้หรือสูญเสียทั้งหมด, การบริการบำรุงรักษาของ Wisedrive หรือการซ่อมรวมจะถูกยกเลิกและจะไม่มีการชดเชยสำหรับช่วงเวลาที่เหลือของระยะเวลาความถูกต้อง. การขอการยกเลิกจะไม่สามารถดำเนินการได้เช่นกัน.',
      'ไม่มีการคืนเงินสำหรับงานบริการที่ผ่านมา.',
      'WiseDrive Technologies (Thailand) Limited ขอสงวนสิทธิ์ในการยกเลิก, ปรับเปลี่ยน, ปรับแต่ง, เพิ่ม, หรือเอาแพ็กเกจใด ๆ, ขอบเขตบริการ, ข้อยกเว้น, การรวม, ฯลฯ โดยไม่ต้องแจ้งล่วงหน้า. สำหรับข้อกำหนดและเงื่อนไขล่าสุด, นโยบาย, และราคา, ฯลฯ กรุณาเยี่ยมชม www.wisedrive.com',
      'การก่อสร้าง, การตีความ, และความหมายของข้อกำหนดและเงื่อนไขเหล่านี้จะถูกกำหนดตามกฎหมายของอินเดีย. ศาลในบangalore จะมีอำนาจในการตัดสินแต่เพียงผู้เดียว.',
      'ผู้ถือการรับประกันต้องยืนยันกับ WiseDrive Technologies (Thailand) Limited ก่อนที่จะดำเนินการซ่อมแซมรถยนต์ในระหว่างระยะเวลาการรับประกัน. หากมีการซ่อมแซมใด ๆ ที่ดำเนินการโดยไม่ได้รับการอนุมัติและยืนยันก่อน, การรับประกันจะเป็นโมฆะ.',
      'ตัวแทนจำหน่ายหรือพนักงานของเขาไม่ได้รับอนุญาตให้ขยายหรือขยายการรับประกันนี้ และตัวแทนจำหน่ายหรือพนักงานของเขาไม่ได้รับอนุญาตให้ให้การรับประกันทางปากในนามของ Wisedrive. การบริการการรับประกันจะให้บริการเฉพาะโดยตัวแทนจำหน่ายที่ได้รับอนุญาตจาก Wisedrive และสาขาบริการของตัวแทนจำหน่าย. การตัดสินใจของ Wisedrive ถือเป็นสุดท้ายและผูกพันกับเจ้าของรถในทุกประเด็นที่เกี่ยวกับการรับประกัน. Wisedrive ขอสงวนสิทธิ์ในการตัดสินใจสุดท้ายในทุกประเด็นที่เกี่ยวกับการรับประกัน.',
      'ตัวแทนจำหน่าย, ตัวแทน, หรือพนักงานของพวกเขาไม่มีอำนาจหรือสิทธิ์ในการอำนวยความสะดวกหรือดำเนินการซ่อมแซมในนามของการรับประกัน Wisedrive. ข้อความนี้ระบุไว้อย่างชัดเจนว่าตัวแทนจำหน่าย, ตัวแทน, หรือพนักงานของพวกเขาห้ามจัดการหรือให้คำมั่นในการซ่อมแซมใด ๆ สำหรับรถยนต์ที่ครอบคลุมโดยการรับประกัน Wisedrive.',
      'ตัวแทนจำหน่าย, ตัวแทน, หรือพนักงานของพวกเขาไม่ได้รับอนุญาตให้ทำการเรียกร้องการรับประกันในนามของลูกค้า. การพยายามทำเช่นนั้นจะถือเป็นการละเมิดข้อกำหนดและเงื่อนไขของข้อตกลงการรับประกัน. การปฏิบัติตามขั้นตอนที่ถูกต้องนี้จะช่วยรักษาความสมบูรณ์ของกระบวนการการรับประกันและรักษาภาระผูกพันตามสัญญาระหว่างลูกค้าและการรับประกัน Wisedrive. การเบี่ยงเบนจากแนวทางเหล่านี้อาจทำให้เกิดการละเมิดข้อตกลงการรับประกันและผลที่ตามมาภายหลัง.',
    ],
    subHeads7:
      'ข้อผูกพันของลูกค้า: ข้อกำหนดใบรับรองความฟิตสำหรับการเรียกร้องการรับประกัน',
    customerObligationFitnessList: [
      'เพื่อให้สามารถเรียกร้องการรับประกันได้ ลูกค้าจะต้องมีใบรับรองความฟิตที่ยังไม่หมดอายุสำหรับรถยนต์ ข้อกำหนดนี้ใช้กับรถยนต์ที่มีอายุเกิน 15 ปี หรือตามที่กฎหมายหรือข้อบังคับของรัฐบาลที่มีผลบังคับใช้กำหนดไว้ หากไม่สามารถแสดงใบรับรองความฟิตที่ถูกต้องเมื่อยื่นคำร้องการรับประกัน การเรียกร้องจะถูกปฏิเสธ.',
      'จำเป็นต้องเข้าใจว่าการแสดงใบรับรองความฟิตเป็นเงื่อนไขที่จำเป็นสำหรับการอนุมัติการเรียกร้องการรับประกัน ข้อกำหนดนี้มีอยู่เพื่อให้มั่นใจว่าเป็นไปตามมาตรฐานทางกฎหมายและข้อบังคับ.',
      'เราขอแนะนำให้ลูกค้าตรวจสอบให้แน่ใจว่ามีใบรับรองความฟิตที่ถูกต้องสำหรับรถยนต์ของตนก่อนที่จะยื่นคำร้องขอการรับประกัน หากไม่สามารถปฏิบัติตามข้อกำหนดนี้ การเรียกร้องอาจถูกปฏิเสธตามข้อกำหนดและเงื่อนไขที่ Wisedrive กำหนดไว้.',
    ],
    subHead8:
      'ข้อผูกพันของลูกค้า: การอัปเดตบัตร RC ใหม่สำหรับการรับประกัน Wisedrive',
    customerObligationRcList: [
      'ลูกค้าต้องรับผิดชอบในการอัปเดตบัตรใบรับรองการจดทะเบียน (RC) ใหม่ของรถยนต์กับ Wisedrive ภายในระยะเวลา 45 วันนับจากวันที่เปิดใช้งานการรับประกัน Wisedrive หากไม่ปฏิบัติตามข้อผูกพันนี้ภายในกรอบเวลา 45 วัน การรับประกัน Wisedrive จะถูกทำให้เป็นโมฆะและไม่มีผลบังคับ.',
      'ในกรณีที่การรับประกันเป็นโมฆะ ลูกค้าสามารถขอการตรวจสอบใหม่ของรถยนต์จากทีมงาน Wisedrive เพื่อคืนสถานะแพ็กเกจการรับประกัน อย่างไรก็ตาม การมีช่องตรวจสอบขึ้นอยู่กับดุลยพินิจและการกำหนดตารางเวลาของทีมงาน Wisedrive ในช่วงระหว่างที่การรับประกันเป็นโมฆะและการตรวจสอบใหม่เสร็จสมบูรณ์ การรับประกันจะไม่สามารถเรียกร้องได้และจะถือเป็นโมฆะ การดำเนินการต่อเนื่องของการรับประกันรถยนต์จะขึ้นอยู่กับดุลยพินิจของทีมงาน Wisedrive และผลการตรวจสอบ.',
      'โปรดทราบว่า Wisedrive ขอสงวนสิทธิ์ในการปฏิเสธการอนุมัติการรับประกันตามผลการตรวจสอบ.',
      'เราขอเน้นย้ำถึงความสำคัญของการปฏิบัติตามข้อผูกพันนี้เพื่อให้การรับประกัน Wisedrive ของคุณยังคงมีผลและครอบคลุมอย่างต่อเนื่อง.',
      'เพื่อที่จะทำการเรียกร้องการรับประกัน เจ้าของรถยนต์จะต้องให้ข้อมูลในใบรับรองการจดทะเบียน (RC book) ของรถยนต์ตรงกับข้อมูลที่ระบุในนโยบายการรับประกัน ความไม่ตรงกันหรือความคลาดเคลื่อนระหว่างข้อมูลของเจ้าของและเอกสารการรับประกันอาจส่งผลให้การเรียกร้องการรับประกันถูกปฏิเสธ.',
      'เป็นความรับผิดชอบของเจ้าของรถยนต์ที่จะต้องตรวจสอบให้แน่ใจว่าข้อมูลใน RC book เช่น ชื่อ, ที่อยู่, และข้อมูลอื่นๆ ถูกต้องและตรงกับข้อมูลที่ระบุในนโยบายการรับประกัน หากมีการเปลี่ยนแปลงหรืออัปเดตข้อมูลใดๆ ควรแจ้งให้ Wisedrive ทราบและทำการสะท้อนการเปลี่ยนแปลงนั้นในทั้ง RC book และเอกสารการรับประกัน.',
      'Wisedrive ขอสงวนสิทธิ์ในการปฏิเสธการเรียกร้องการรับประกันหากไม่ปฏิบัติตามข้อกำหนดเหล่านี้. แนะนำให้เจ้าของรถยนต์ตรวจสอบและยืนยันความถูกต้องของข้อมูลในทั้ง RC book และนโยบายการรับประกันเพื่อหลีกเลี่ยงปัญหาหรือการปฏิเสธการเรียกร้องการรับประกัน.',
    ],

    subHead9: 'ความรับผิดชอบของเจ้าของรถ:',
    responsibilitiesList: [
      'การใช้งาน, การบำรุงรักษา, และการดูแลรักษารถยนต์ให้เหมาะสมตามคำแนะนำที่ระบุในคู่มือเจ้าของรถและสมุดบันทึกการบริการ หากรถยนต์ถูกใช้งานในสภาพแวดล้อมที่รุนแรง เช่น การขับในสภาพฝุ่นหนา, การขับในเส้นทางขรุขระ, การขับระยะทางสั้นบ่อยๆ หรือการจราจรในเมืองที่แออัดในช่วงอากาศร้อน, ควรบำรุงรักษารถยนต์บ่อยขึ้นตามที่ระบุในคู่มือเจ้าของรถและสมุดบันทึกการบริการ.',
      'เพื่อรักษาความถูกต้องของการรับประกันขยายนี้ รถยนต์ต้องได้รับการบริการจากศูนย์บริการตัวแทนจำหน่าย Wisedrive ที่ได้รับอนุญาตตามคำแนะนำในคู่มือเจ้าของรถและสมุดบันทึกการบริการ.',
      'การเก็บบันทึกการบริการบำรุงรักษา อาจจำเป็นที่ลูกค้าต้องแสดงว่ามีการบำรุงรักษารถยนต์ตามที่ระบุในคู่มือเจ้าของรถและสมุดบันทึกการบริการ.',
      'การนำรถยนต์พร้อมกับคู่มือเจ้าของรถ, สมุดบันทึกการบริการ, และใบรับประกันขยายไปที่ตัวแทนจำหน่าย Wisedrive ที่ได้รับอนุญาตในช่วงเวลาทำการปกติเพื่อขอรับบริการตามการรับประกัน.',
    ],
    subHead10:
      'ข้อผิดพลาดของผู้ขับขี่/คู่มือที่ไม่ครอบคลุมในการเรียกร้องการรับประกัน',
    subTitle1: 'ความล้มเหลวในการรักษาระดับน้ำมันเครื่องที่เหมาะสม:',
    subTitleList: [
      'การละเลยในการตรวจสอบและรักษาระดับน้ำมันเครื่องตามที่แนะนำ.',
      'การขาดน้ำมันหล่อลื่นทำให้เกิดความเสียดทานที่เพิ่มขึ้นและการสึกหรอของส่วนประกอบของเครื่องยนต์.',
      'ผลกระทบที่อาจเกิดขึ้น: ความล้มเหลวของเครื่องยนต์, ความเสียหายที่เกิดขึ้นกับชิ้นส่วนภายใน.',
    ],

    subTitle2: 'การละเลยช่วงเวลาในการเปลี่ยนน้ำมันเครื่อง:',
    subTitle2List: [
      'การละเลยในการเปลี่ยนน้ำมันเครื่องตามกำหนดทำให้น้ำมันเสื่อมสภาพและลดการหล่อลื่น.',
      'น้ำมันที่ปนเปื้อนทำให้เกิดการสึกหรอของเครื่องยนต์และอาจทำให้เครื่องยนต์เสียหาย.',
      'ผลกระทบที่อาจเกิดขึ้น: ความล้มเหลวของเครื่องยนต์, การลดประสิทธิภาพของเครื่องยนต์.',
    ],
    subTitle3: 'การทำให้เครื่องยนต์ร้อนเกินไป:',
    subTitle3List: [
      'การปล่อยให้เครื่องยนต์ร้อนเกินไปเนื่องจากการขัดข้องของระบบระบายความร้อนหรือน้ำหล่อเย็นต่ำ.',
      'การเครียดเกินไปกับเครื่องยนต์ทำให้เกิดความเสียหายรุนแรง.',
      'ผลกระทบที่อาจเกิดขึ้น: ฝาสูบบิดเบี้ยว, ปะเก็นฝาสูบแตก, เครื่องยนต์หยุดทำงาน.',
    ],
    subTitle4: 'การใช้น้ำมันหรือเครื่องยนต์ผิดประเภท:',
    subTitle4List: [
      'การใช้น้ำมันผิดประเภท (เช่น การใช้น้ำมันเบนซินแทนน้ำมันดีเซล) หรือการใช้น้ำมันเครื่องที่ไม่เหมาะสม.',
      'การแทรกแซงกระบวนการเผาไหม้ของเครื่องยนต์และประสิทธิภาพที่ลดลง.',
      'ผลกระทบที่อาจเกิดขึ้น: ความเสียหายของเครื่องยนต์, การลดประสิทธิภาพในการใช้น้ำมัน.',
    ],
    subTitle5: 'การมองข้ามสัญญาณเตือน:',
    subTitle5List: [
      'การมองข้ามสัญญาณเตือนจากเครื่องยนต์ เช่น เสียงแปลก, ควันมากเกินไป, การสูญเสียพลัง, หรือไฟเตือนบนแผงหน้าปัด.',
      'การไม่แก้ไขปัญหาที่เกิดขึ้นในระยะแรกของเครื่องยนต์.',
      'ผลกระทบที่อาจเกิดขึ้น: ความเสียหายเพิ่มเติม, ความล้มเหลวของเครื่องยนต์, ความปลอดภัยที่ลดลง.',
    ],
    subTitle6:
      'การหมุนรอบเครื่องยนต์มากเกินไปหรือการเร่งเครื่องจนเกินขีดจำกัด:',
    subTitle6List: [
      'การหมุนรอบเครื่องยนต์มากเกินไปหรือการใช้งานเครื่องยนต์ที่ความเร็วรอบสูงอย่างต่อเนื่อง.',
      'การทำให้เกิดความเครียดกับส่วนประกอบของเครื่องยนต์มากเกินไปและการสึกหรอที่เพิ่มขึ้น.',
      'ผลกระทบที่อาจเกิดขึ้น: การสึกหรอของเครื่องยนต์ที่เพิ่มขึ้น, อายุการใช้งานของเครื่องยนต์ที่ลดลง.',
      'การบำรุงรักษาที่ไม่เหมาะสมและการละเลย:',
      'การไม่ทำงานบำรุงรักษาตามระยะเวลา (เช่น การเปลี่ยนสายพาน, การเปลี่ยนหัวเทียน, การเปลี่ยนฟิลเตอร์อากาศ).',
      'การเสื่อมสภาพของส่วนประกอบของเครื่องยนต์จากการละเลย.',
      'ผลกระทบที่อาจเกิดขึ้น: ปัญหาเครื่องยนต์, ประสิทธิภาพที่ลดลง, ความเสี่ยงในการล้มเหลวที่เพิ่มขึ้น.',
    ],
    subNote:
      'ควรทราบว่า รายการนี้ไม่ครอบคลุมทั้งหมด และรุ่นรถยนต์เฉพาะอาจมีข้อกำหนดและคำแนะนำเพิ่มเติมที่ระบุในคู่มือเจ้าของของแต่ละรุ่น โปรดอ้างอิงคำแนะนำของผู้ผลิตและทำตามขั้นตอนการบำรุงรักษาที่ถูกต้องเพื่อให้ยืดอายุการใช้งานและประสิทธิภาพของรถของคุณ.',
    noteHeader: 'หมายเหตุสำคัญ:',
    noteList: [
      'ประกันระยะเวลาขยายนี้สามารถโอนให้เจ้าของคนถัดไปได้สำหรับระยะเวลาที่เหลือของประกัน หลังจากการอนุมัติการตรวจสอบใหม่.',
      'Wisedrive มีสิทธิ์ยกเลิก/ปฏิเสธคำขอโอนประกันตามการตรวจสอบใหม่.',
      'แผนประกันระยะเวลาขยายนี้ไม่มีมูลค่าสิทธิ์คืนเงิน, ไม่มีการคืนเงินเบี้ยประกัน และไม่สามารถโอนให้กับรถคันอื่นได้.',
      'ประกันระยะเวลาขยายไม่สามารถใช้ได้กับรถแท็กซี่/ฟลีทและรถสำหรับทดสอบขับขี่.',
      'บริการบำรุงรักษาทั้งหมดและการซ่อมแซมที่มีการเรียกร้องการรับประกันจะดำเนินการที่ศูนย์บริการที่ได้รับการอนุมัติจาก Wisedrive ในระดับอำเภอภายในรัฐกรณาฏกะเท่านั้น.',
      'เจ้าของประกันต้องนำเสนอประกันภัยรถยนต์ที่มีผลเมื่อยื่นคำร้องขอการเคลมประกัน หากไม่มีการแสดงหลักฐานประกันภัยจะทำให้การเคลมประกันเป็นโมฆะ.',
      'คำร้องขอการเคลมประกันสำหรับการครอบคลุมประกันนอกพื้นที่รัฐกรณาฏกะจะไม่พิจารณาว่าเป็นไปได้หรือมีความเป็นไปได้.',
      'บริการบำรุงรักษาทั้งหมดสำหรับคำร้องขอบริการนอกพื้นที่รัฐกรณาฏกะจะไม่ถือว่าเป็นไปได้หรือมีความเป็นไปได้.',
      'ราคาประกันระยะเวลาขยายอาจมีการเปลี่ยนแปลงโดยไม่ต้องแจ้งล่วงหน้า.',
      'ตัวเลือกประกันระยะเวลาขยายทั้งหมดอาจมีการเปลี่ยนแปลง/หมดอายุโดยไม่ต้องแจ้งล่วงหน้า.',
      'เจ้าของประกันต้องยื่นคำร้องขอ/ข้อสงสัยผ่านช่องทางช่วยเหลือ (อีเมล- support.th@wisedrive.com, หมายเลขโทรศัพท์ - +66 81 899 4420) ภายใน 48 ชั่วโมงหลังจากเกิดเหตุการณ์การเคลม มิฉะนั้นการเคลมจะถือว่าไม่ถูกต้อง.',
      'ข้อพิพาททั้งหมดที่เกิดจากประกันระยะเวลาขยายนี้จะอยู่ภายใต้เขตอำนาจของศาลในบังกาลอร์เท่านั้น.',
      'Wisedrive ขอสงวนสิทธิ์ในการปรับปรุงหรือเปลี่ยนแปลงคุณลักษณะหรือการออกแบบของแผนประกันทั้งหมดของ Wisedrive ได้ทุกเมื่อโดยไม่ต้องมีข้อผูกมัดกับรถที่ได้รับการประกันแล้ว สำหรับเงื่อนไขล่าสุด นโยบาย และราคา โปรดเยี่ยมชม www.wisedrive.com หรือ ติดต่อฝ่ายสนับสนุนลูกค้า Wisedrive ที่หมายเลข +66 81 899 4420 หรืออีเมล support.th@wisedrive.com.',
    ],
  },
  inspectionTerms: {
    header: 'ข้อกำหนดและเงื่อนไขการตรวจสอบ',
    contentArray: [
      {
        data: (
          <>
            <strong>"เรา/พวกเรา" และ "เรา" </strong>
            หมายถึง WiseDrive Technologies (Thailand) Limited
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ข้อตกลง" </strong>หมายถึงข้อตกลงระหว่าง Wisedrive และลูกค้า
            ซึ่ง Wisedrive
            ตกลงจัดให้มีผู้ตรวจสอบทำการตรวจสอบตามข้อกำหนดและเงื่อนไขนี้
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ค่าธรรมเนียมการยกเลิก" </strong>
            หมายถึงจำนวนเงินที่ลูกค้าต้องชำระตามที่ระบุไว้ในข้อกำหนดและเงื่อนไขนี้
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ลูกค้า/คุณ" </strong>หมายถึงลูกค้าของ Wisedrive
            ที่สั่งซื้อตรวจสอบ
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ค่าธรรมเนียม" </strong>หมายถึงจำนวนเงินที่ลูกค้าต้องชำระให้
            Wisedrive สำหรับการตรวจสอบ ตามที่ระบุไว้ที่
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"การตรวจสอบ" </strong>
            หมายถึงการตรวจสอบภายนอกของยานพาหนะผ่านสื่อเสียงและภาพ
            รวมถึงการทดสอบการขับขี่ที่ดำเนินการโดยผู้ตรวจสอบในนามของ Wisedrive
            สำหรับลูกค้าตามข้อกำหนดและเงื่อนไขนี้
          </>
        ),
      },
      {
        data: (
          <>
            Wisedrive มีประเภทการตรวจสอบที่แตกต่างกัน
            ซึ่งแต่ละประเภทประกอบด้วยการตรวจสอบที่ต่างกัน
            รายละเอียดของประเภทการตรวจสอบและรายการตรวจสอบสามารถดูได้ที่
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
            หรือโทร +66 81 899 4420
            การยืนยันประเภทของการตรวจสอบที่ลูกค้าเลือกให้ดำเนินการกับยานพาหนะ
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ผู้ตรวจสอบ" </strong>
            หมายถึงผู้ตรวจสอบที่มีคุณสมบัติเหมาะสมซึ่งดำเนินการตรวจสอบในนามของ
            Wisedrive โดยขึ้นอยู่กับความพร้อมให้บริการ
            และอาจรวมถึงตัวแทนภายนอกที่เหมาะสม
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"รายงาน" </strong>
            หมายถึงรายงานที่เป็นลายลักษณ์อักษรที่ผู้ตรวจสอบจัดทำขึ้นระหว่างการตรวจสอบ
            ซึ่งรวมถึงชื่อและที่อยู่ของลูกค้า
            รายละเอียดการลงทะเบียนของยานพาหนะที่ตรวจสอบ
            ตำแหน่งที่ตั้งของยานพาหนะ ผลการตรวจสอบ (ผ่านหรือไม่ผ่าน)
            รายการตรวจสอบที่ดำเนินการ
            (ขึ้นอยู่กับประเภทของการตรวจสอบที่ลูกค้าต้องการ)
            และข้อกังวลที่ผู้ตรวจสอบเห็นว่าควรแจ้งให้ลูกค้าทราบ
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"รายการตรวจสอบรายงาน" </strong>
            หมายถึงรายการที่ผู้ตรวจสอบได้ตรวจสอบในระหว่างการตรวจสอบทางกายภาพ
            ซึ่งสามารถดูได้ที่
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>"ยานพาหนะ" </strong>
            หมายถึงยานพาหนะที่ลูกค้าต้องการให้ผู้ตรวจสอบดำเนินการตรวจสอบ
          </>
        ),
      },
    ],
    subHeader3: (
      <>
        <strong>การทดสอบขับขี่</strong>
      </>
    ),
    listContent2: [
      <>
        เพื่อให้ผู้ตรวจสอบของเราสามารถดำเนินการทดสอบขับขี่บนรถยนต์ของคุณได้
        คุณต้องตรวจสอบให้แน่ใจว่ารถมี:
        <br /> (a) น้ำเพียงพอ; <br /> (b) น้ำมันเครื่องเพียงพอ;
        <br /> (c) น้ำมันเชื้อเพลิงเพียงพอ
      </>,
      'การทดสอบขับขี่จะดำเนินการภายในพื้นที่ใกล้เคียงกับจุดตรวจสอบ หาก:',
      'รถยนต์อยู่ในสภาพที่ไม่พร้อมใช้งานบนท้องถนน หรือมีน้ำมันเครื่อง น้ำ หรือ น้ำมันเชื้อเพลิงไม่เพียงพอ',
      'ลูกค้าไม่สามารถยืนยันได้ว่ารถมีใบรับรองความปลอดภัยที่ถูกต้อง และทำให้ไม่สามารถดำเนินการทดสอบขับขี่ได้ในระหว่างการตรวจสอบ',
      'ค่าธรรมเนียมสำหรับการตรวจสอบจะต้องชำระเต็มจำนวน และจะมีค่าธรรมเนียมเพิ่มเติมหากคุณต้องการให้เราดำเนินการทดสอบขับขี่ในภายหลัง',
      'การดำเนินการทดสอบขับขี่ไม่ได้หมายความว่าผู้ตรวจสอบของเราได้เห็นใบรับรองความปลอดภัยที่ถูกต้อง',
      'การขออนุญาตที่จำเป็นและการเข้าถึงรถยนต์เป็นความรับผิดชอบของลูกค้า ลูกค้าต้องตรวจสอบให้แน่ใจว่ามีการจัดเตรียมพื้นที่ที่เหมาะสม (รวมถึงการได้รับอนุญาตจากเจ้าของรถยนต์) เพื่อให้การตรวจสอบสามารถดำเนินการในอู่ซ่อมรถหรือบริเวณที่มีพื้นที่แข็งแรง แห้ง และราบเรียบ',
      'ผู้ตรวจสอบของเราต้องการพื้นที่เพียงพอในการเดินรอบรถและเปิดประตูทุกบานได้อย่างเต็มที่ รวมถึงต้องมีที่จอดรถสำหรับรถของผู้ตรวจสอบใกล้กับจุดตรวจสอบ',
      'ต้องมีแสงสว่างที่เหมาะสม เช่น แสงในร่มที่มีคุณภาพดี หรือแสงแดดหากรถจอดอยู่นอกอาคาร เราไม่สามารถตรวจสอบรถในที่แสงน้อยหรือมืดได้',
    ],

    subHeader4: 'ค่าธรรมเนียมและการยกเลิก',
    listContent3: [
      'ค่าธรรมเนียมจะต้องชำระในขณะที่ทำการจองการตรวจสอบ',
      <>
        เราขอสงวนสิทธิ์ในการปฏิเสธการตรวจสอบหรือออกใบรายงานสำหรับรถยนต์ที่:
        <br /> (a) ผู้ตรวจสอบไม่สามารถเข้าถึงได้อย่างเหมาะสม; หรือ
        <br /> (b) มีลักษณะที่ไม่ได้มาจากการผลิตมาตรฐาน (เช่น รถประกอบเอง);
        <br /> (c) มีการดัดแปลงหรือไม่ได้ถูกใช้งานเป็นประจำ (เช่น
        มีร่องรอยการกัดกร่อนจากการจอดทิ้งไว้นาน
        และอาจทำให้รถไม่ปลอดภัยต่อการขับขี่);
        <br /> (d) ไม่พร้อมใช้งานบนท้องถนนหรือไม่ปลอดภัยต่อการขับขี่
      </>,
      'กรณีที่กล่าวถึงในข้อกำหนดและเงื่อนไขเหล่านี้',
      'หากลูกค้าไม่ได้จัดเตรียมสถานที่ที่เหมาะสมสำหรับการตรวจสอบตามที่กำหนด',
      'หากลูกค้าให้ข้อมูลที่ไม่ถูกต้องหรือไม่ครบถ้วน ทำให้เราไม่สามารถดำเนินการตรวจสอบได้ ลูกค้ารับทราบว่าในกรณีดังกล่าว เรามีสิทธิ์ยุติสัญญาและเก็บค่าธรรมเนียมทั้งหมด หากลูกค้าต้องการให้เราดำเนินการตรวจสอบใหม่ จะต้องชำระค่าธรรมเนียมใหม่ในขณะที่ทำการจอง',
      'ลูกค้ามีสิทธิ์ยกเลิกการตรวจสอบและขอรับเงินคืนเต็มจำนวนได้ หากแจ้งยกเลิกก่อนเวลานัดตรวจสอบ 24 ชั่วโมง หลังจากที่การตรวจสอบดำเนินการแล้ว จะไม่มีการคืนเงิน',
      'หากต้องการยกเลิกการตรวจสอบ ลูกค้าต้องแจ้งทีมสนับสนุนของเราทางอีเมลที่ support.th@wisedrive.com หรือโทร +66 81 899 4420 ในวันจันทร์ถึงศุกร์ เวลา 9:00 น. - 17:00 น. กรุณาให้ข้อมูลชื่อ ที่อยู่ เบอร์โทรศัพท์ และหมายเลขการจองของคุณ (ตามที่ระบุในอีเมลยืนยันการจอง) พร้อมคำขอยกเลิกของคุณ',
    ],
    subHeader5: 'การร้องเรียน',
    listContent4: [
      'หากคุณมีข้อร้องเรียนหรือไม่พอใจกับการตรวจสอบที่ดำเนินการ กรุณาติดต่อเราที่ +66 81 899 4420 โดยเร็วที่สุด เราอาจต้องตรวจสอบรถยนต์อีกครั้งเพื่อจัดการกับข้อร้องเรียน และคุณตกลงที่จะอนุญาตให้เราทำเช่นนั้น',
      'ห้ามซ่อมแซมหรือเปลี่ยนอะไหล่ใด ๆ ในรถยนต์ที่เป็นหัวข้อของข้อร้องเรียนก่อนที่เราจะได้ทำการตรวจสอบซ้ำ หากจำเป็นต้องมีการซ่อมแซมฉุกเฉินเพื่อให้รถอยู่ในสภาพปลอดภัย และต่อมาจะมีการร้องเรียนเกี่ยวกับรถ คุณต้องแจ้งให้เราทราบถึงข้อร้องเรียน (รวมถึงการแจ้งเกี่ยวกับความจำเป็นในการซ่อมแซมฉุกเฉิน) ภายในระยะเวลาที่เหมาะสมหลังจากพบปัญหา และต้องเก็บอะไหล่ที่เสียหายหรือถูกเปลี่ยนไว้เพื่อให้เราตรวจสอบในภายหลัง เราจะไม่รับผิดชอบต่อค่าใช้จ่ายในการซ่อมแซมหรือเปลี่ยนอะไหล่ที่ดำเนินการไปโดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากเราก่อน',
      'เราขอสงวนสิทธิ์ในการให้ผู้ตรวจสอบของเราตรวจสอบรถอีกครั้งโดยไม่มีค่าใช้จ่ายเพิ่มเติม หากเราพิจารณาแล้วว่าเป็นสิ่งจำเป็นในการจัดการข้อร้องเรียน และคุณต้องอนุญาตให้ผู้ตรวจสอบของเราทำการตรวจสอบซ้ำตามข้อกำหนดและเงื่อนไขเหล่านี้ เราจะให้ความเห็นที่เป็นกลางเพิ่มเติมเกี่ยวกับรายงานฉบับแรกที่ออกให้',
    ],

    subHeader6: 'เหตุการณ์ที่อยู่นอกเหนือการควบคุมของเรา',
    listContent5: [
      'เราจะไม่รับผิดชอบต่อความล่าช้าหรือการไม่สามารถดำเนินการตรวจสอบได้อันเนื่องมาจากเหตุการณ์หรือสถานการณ์ที่อยู่นอกเหนือการควบคุมของเรา เราจะพยายามลดผลกระทบจากสถานการณ์ดังกล่าวให้มากที่สุดเท่าที่จะเป็นไปได้',
      'Wisedrive จะรับผิดชอบต่อลูกค้า (แต่ไม่ใช่บุคคลอื่น) ในขอบเขตที่ Wisedrive ไม่สามารถดำเนินการตรวจสอบตามข้อกำหนดและเงื่อนไขเหล่านี้ได้ โดยไม่จำกัดข้อกำหนดดังกล่าว คุณรับทราบว่า Wisedrive หรือผู้ตรวจสอบจะไม่รับผิดชอบต่อคุณหรือบุคคลอื่นสำหรับความรับผิด ความสูญเสีย ความเสียหาย ข้อเรียกร้อง การดำเนินคดี ค่าใช้จ่าย หรือค่าใช้จ่ายอื่น ๆ (รวมเรียกว่า "ความสูญเสีย") ที่เกิดขึ้นในสถานการณ์ต่อไปนี้:',
      'ความสูญเสียดังกล่าวไม่ใช่ผลลัพธ์ที่สามารถคาดการณ์ได้อย่างสมเหตุสมผลจากการละเมิดเงื่อนไข (สามารถคาดการณ์ได้หากคุณและเราคาดไว้ในขณะที่ทำการตรวจสอบรถ)',
      'ความสูญเสียดังกล่าวไม่ได้เกิดขึ้นโดยตรงจากการละเมิดเงื่อนไขของเราหรือผู้ตรวจสอบ',
      'ความสูญเสียดังกล่าวเกี่ยวข้องกับธุรกิจหรือความเสียหายอื่น ๆ ที่เกี่ยวข้องกับลูกค้าที่ไม่ใช่ผู้บริโภค',
      'ความสูญเสียดังกล่าวเพิ่มขึ้นเนื่องจากการละเมิดเงื่อนไขของคุณในข้อตกลงนี้',
      'ไม่มีสิ่งใดในที่นี้จะมีผลกระทบต่อสิทธิ์ตามกฎหมายของผู้บริโภคภายใต้กฎหมายที่เกี่ยวข้อง',
    ],

    subHeader7: 'การบังคับใช้เงื่อนไข',
    listContent6: [
      'เงื่อนไขแต่ละข้อของข้อตกลงนี้มีผลบังคับใช้แยกกัน หากศาลหรือหน่วยงานที่เกี่ยวข้องตัดสินว่าเงื่อนไขใด ๆ ไม่ชอบด้วยกฎหมาย เงื่อนไขอื่น ๆ ยังคงมีผลบังคับใช้อย่างสมบูรณ์',
      'ข้อตกลงนี้เป็นระหว่างคุณและ Wisedrive ไม่มีบุคคลอื่นใดที่มีสิทธิ์ในการบังคับใช้เงื่อนไขของข้อตกลงนี้ และไม่มีฝ่ายใดจำเป็นต้องได้รับความยินยอมจากบุคคลอื่นเพื่อทำการเปลี่ยนแปลงเงื่อนไขเหล่านี้',
    ],

    subHeader8: 'คำแนะนำเกี่ยวกับรายงาน',
    listContent7: [
      'เราแนะนำให้คุณพูดคุยเกี่ยวกับผลการตรวจสอบในรายงานกับผู้ขายก่อนตัดสินใจซื้อรถ หากคุณยังไม่ได้ดูรถด้วยตนเอง คุณต้องตรวจสอบให้แน่ใจว่าลักษณะภายนอกและสเปกของรถตรงกับความต้องการและความคาดหวังของคุณ เราขอแนะนำให้คุณดูและทดลองขับรถด้วยตนเองก่อนตัดสินใจซื้อ',
    ],
  },
  aiComponent: {
    header: 'เพิ่มความไว้วางใจและความโปร่งใสในการตรวจสอบรถมือสองด้วย AI/ML',
    description:
      'Wisedrive ใช้อัลกอริธึมขั้นสูงในการตรวจจับ, จัดประเภท และวิเคราะห์รูปแบบเสียงของเครื่องยนต์ เทคโนโลยีนี้ช่วยระบุปัญหาต่างๆ เช่น การจุดระเบิดผิดพลาด, การสั่นสะเทือนที่ไม่สม่ำเสมอ หรือการสึกหรอ ทำให้สามารถบำรุงรักษาเชิงรุกได้ ช่วยให้เครื่องยนต์ทำงานได้ดีขึ้น, มีความน่าเชื่อถือ และมีประสิทธิภาพในการดำเนินงาน',
    cardData: [
      {
        header: '20x',
        subtitle: 'วิเคราะห์เครื่องยนต์ได้แม่นยำยิ่งขึ้น',
        description:
          'AI ของเราที่ได้รับการฝึกฝนด้วยเสียงเครื่องยนต์กว่าล้านเสียง สามารถวิเคราะห์เครื่องยนต์ได้อย่างแม่นยำยิ่งขึ้นและตรวจจับปัญหาที่เกี่ยวข้องได้ดีขึ้น',
      },
      {
        header: '95%',
        subtitle: 'ลดข้อผิดพลาดจากมนุษย์',
        description:
          'การตรวจสอบของเราช่วยลดการแทรกแซงของมนุษย์ และเพิ่มคุณภาพของรายงานโดยใช้ AI และ ML',
      },
      {
        header: '75%',
        subtitle: 'ลดระยะเวลาการตรวจสอบ',
        description:
          'เทคโนโลยีของเราช่วยลดระยะเวลาการตรวจสอบลง 75% และสามารถส่งรายงานผลการตรวจสอบได้ภายใน 30 นาที',
      },
      {
        header: '100%',
        subtitle: 'รับประกันคุณภาพการตรวจสอบ',
        description:
          'AI ของเรารับประกันคุณภาพการตรวจสอบ 100% ด้วยการวิเคราะห์เสียงขั้นสูงและการวิเคราะห์เครื่องยนต์โดยใช้เครื่องสแกน OBD2',
      },
    ],
  },
  cancellationAndRefund: {
    header: 'นโยบายการยกเลิกและการคืนเงิน',
    dataArray: [
      {
        subHeader: '1. ภายในระยะเวลา 10 วันแรก',
        description:
          'ผู้ถือกรมธรรม์รับประกัน / ตัวแทนจำหน่ายทุกคนที่ได้ซื้อกรมธรรม์รับประกันเพิ่มเติมจาก WiseDrive Technologies (Thailand) Limited สามารถยื่นคำขอยกเลิกกรมธรรม์และขอรับเงินคืนเต็มจำนวนได้ภายใน 10 (สิบ) วันปฏิทิน นับจากวันที่ได้รับชำระค่าเบี้ยประกันภัย ผู้ถือกรมธรรม์ / ตัวแทนจำหน่ายต้องส่งคำขอยกเลิกและขอคืนเงินเป็นลายลักษณ์อักษรผ่านทางอีเมลไปยัง WiseDrive Technologies (Thailand) Limited ที่ support.th@wisedrive.com ("คำขอยกเลิก") หลังจากได้รับคำขอยกเลิกภายในระยะเวลาที่กำหนด WiseDrive Technologies (Thailand) Limited จะทำการยกเลิกกรมธรรม์และคืนเงินจำนวนเต็มที่ผู้ถือกรมธรรม์ / ตัวแทนจำหน่ายได้ชำระไป ทั้งนี้ กรมธรรม์รับประกันและสิทธิ์ทั้งหมดภายใต้กรมธรรม์รับประกันจะสิ้นสุดลงทันทีตั้งแต่วันที่ทำการยกเลิกกรมธรรม์ และ WiseDrive Technologies (Thailand) Limited จะไม่รับพิจารณาคำร้องใดๆ จากผู้ถือกรมธรรม์ / ตัวแทนจำหน่ายหลังจากวันที่คำขอยกเลิกถูกส่งมา',
      },
      {
        subHeader: '2. การยื่นคำขอยกเลิกหลังจาก 10 วันแรก',
        description:
          'ผู้ถือกรมธรรม์รับประกันมีสิทธิ์ขอคืนเงินได้ก็ต่อเมื่อทำการยกเลิกกรมธรรม์ภายใน 10 วันนับจากวันที่ชำระค่าเบี้ยประกันภัยเท่านั้น ผู้ถือกรมธรรม์ยังสามารถยื่นคำขอยกเลิกหลังจากระยะเวลาที่กำหนดได้ อย่างไรก็ตาม WiseDrive Technologies (Thailand) Limited จะไม่ทำการคืนเงินสำหรับคำขอยกเลิกที่ได้รับหลังจากช่วงเวลาดังกล่าว',
      },
      {
        subHeader: '3. การชำระเงินและวิธีการคืนเงิน',
        description:
          'สำหรับคำขอยกเลิกที่ทำภายใน 10 วันนับจากวันที่ชำระเงิน การคืนเงินจะดำเนินการภายใน 14 (สิบสี่) วันทำการ นับจากวันที่ได้รับคำขอยกเลิก การคืนเงินจะถูกโอนไปยังช่องทางการชำระเงินเดิมที่ผู้ถือกรมธรรม์ใช้ในการชำระเงินครั้งแรก หรือ WiseDrive Technologies (Thailand) Limited อาจดำเนินการคืนเงินผ่านช่องทางอื่น ตามที่ได้รับคำแนะนำจากผู้ถือกรมธรรม์ พร้อมรายละเอียดที่จำเป็นในคำขอยกเลิก',
      },
    ],
  },
  privacyData: {
    header:
      'นโยบายความเป็นส่วนตัวของ WiseDrive Technologies (Thailand) Limited',
    contentArray: [
      {
        subHeader: 'เราทำอะไรกับข้อมูลของคุณ?',
        subContent:
          'เมื่อคุณซื้อสินค้าจากร้านค้าของเรา ในกระบวนการซื้อขาย เราจะรวบรวมข้อมูลส่วนบุคคลของคุณ เช่น ชื่อ ที่อยู่ และที่อยู่อีเมลของคุณ เมื่อคุณเรียกดูร้านค้าของเรา เราจะได้รับที่อยู่โปรโตคอลอินเทอร์เน็ต (IP) ของคอมพิวเตอร์ของคุณโดยอัตโนมัติเพื่อให้เราทราบข้อมูลเกี่ยวกับเบราว์เซอร์และระบบปฏิบัติการของคุณ อีเมลทางการตลาด (หากมี): หากคุณอนุญาต เราอาจส่งอีเมลถึงคุณเกี่ยวกับร้านค้าของเรา ผลิตภัณฑ์ใหม่ และการอัปเดตอื่น ๆ',
      },
      {
        subHeader: 'ความยินยอม',
        subContent:
          'คุณให้ความยินยอมของคุณอย่างไร? เมื่อคุณให้ข้อมูลส่วนบุคคลแก่เราเพื่อทำธุรกรรม ยืนยันบัตรเครดิตของคุณ ทำการสั่งซื้อ จัดส่ง หรือคืนสินค้า เราถือว่าคุณยินยอมให้เรารวบรวมและใช้ข้อมูลดังกล่าวเพื่อวัตถุประสงค์เฉพาะนั้นเท่านั้น หากเราขอข้อมูลส่วนบุคคลของคุณด้วยเหตุผลรอง เช่น การตลาด เราจะขอความยินยอมจากคุณโดยตรง หรือให้โอกาสคุณปฏิเสธได้ คุณสามารถเพิกถอนความยินยอมของคุณได้อย่างไร? หากคุณเปลี่ยนใจหลังจากที่เคยยินยอม คุณสามารถเพิกถอนความยินยอมของคุณเพื่อให้เราติดต่อคุณหรือเก็บ ใช้ หรือเปิดเผยข้อมูลของคุณได้ทุกเมื่อ โดยติดต่อเราที่ support.th@wisedrive.com',
      },
      {
        subHeader: 'การเปิดเผยข้อมูล',
        subContent:
          'เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณหากกฎหมายกำหนดให้เราทำเช่นนั้น หรือหากคุณละเมิดข้อกำหนดในการให้บริการของเรา',
      },
      {
        subHeader: 'การชำระเงิน',
        subContent:
          'เรานำ Razorpay มาใช้ในการประมวลผลการชำระเงิน เรา/Razorpay จะไม่จัดเก็บข้อมูลบัตรของคุณบนเซิร์ฟเวอร์ของพวกเขา ข้อมูลจะถูกเข้ารหัสตามมาตรฐานความปลอดภัยของข้อมูลบัตรชำระเงิน (PCI-DSS) ระหว่างการประมวลผลการชำระเงิน ข้อมูลธุรกรรมของคุณจะถูกใช้เฉพาะในช่วงเวลาที่จำเป็นสำหรับการทำธุรกรรมให้เสร็จสิ้นเท่านั้น หลังจากนั้น ข้อมูลธุรกรรมของคุณจะไม่ถูกเก็บรักษา ระบบการชำระเงินของเราปฏิบัติตามมาตรฐาน PCI-DSS ซึ่งบริหารโดยคณะกรรมการมาตรฐานความปลอดภัย PCI ซึ่งเป็นความร่วมมือของแบรนด์ต่าง ๆ เช่น Visa, MasterCard, American Express และ Discover มาตรฐาน PCI-DSS ช่วยให้มั่นใจได้ว่าข้อมูลบัตรเครดิตของคุณได้รับการจัดการอย่างปลอดภัยโดยร้านค้าและผู้ให้บริการของเรา หากต้องการทราบข้อมูลเพิ่มเติม โปรดอ่านข้อกำหนดและเงื่อนไขของ Razorpay',
      },
      {
        subHeader: 'บริการจากบุคคลที่สาม',
        subContent:
          'โดยทั่วไปแล้ว ผู้ให้บริการบุคคลที่สามที่เราใช้จะรวบรวม ใช้ และเปิดเผยข้อมูลของคุณในขอบเขตที่จำเป็นสำหรับให้บริการแก่เรา อย่างไรก็ตาม ผู้ให้บริการบุคคลที่สามบางราย เช่น เกตเวย์การชำระเงิน และตัวประมวลผลธุรกรรมการชำระเงิน อาจมีนโยบายความเป็นส่วนตัวของตนเองเกี่ยวกับข้อมูลที่เราต้องให้พวกเขาเพื่อทำธุรกรรมของคุณ สำหรับผู้ให้บริการเหล่านี้ เราขอแนะนำให้คุณอ่านนโยบายความเป็นส่วนตัวของพวกเขาเพื่อให้คุณเข้าใจว่าข้อมูลส่วนบุคคลของคุณจะถูกจัดการอย่างไร โปรดทราบว่าผู้ให้บริการบางรายอาจตั้งอยู่หรือมีสิ่งอำนวยความสะดวกในเขตอำนาจศาลที่แตกต่างจากคุณหรือเรา ดังนั้น หากคุณเลือกดำเนินการธุรกรรมที่เกี่ยวข้องกับผู้ให้บริการบุคคลที่สาม ข้อมูลของคุณอาจอยู่ภายใต้กฎหมายของเขตอำนาจศาลที่ผู้ให้บริการตั้งอยู่ เมื่อคุณออกจากเว็บไซต์ร้านค้าของเราหรือถูกเปลี่ยนเส้นทางไปยังเว็บไซต์หรือแอปพลิเคชันของบุคคลที่สาม คุณจะไม่อยู่ภายใต้นโยบายความเป็นส่วนตัวนี้หรือข้อกำหนดในการให้บริการของเว็บไซต์ของเราอีกต่อไป ลิงก์ เมื่อคุณคลิกลิงก์ในร้านค้าของเรา ลิงก์เหล่านั้นอาจนำคุณออกจากเว็บไซต์ของเรา เราไม่รับผิดชอบต่อแนวทางปฏิบัติด้านความเป็นส่วนตัวของเว็บไซต์อื่น และขอแนะนำให้คุณอ่านคำชี้แจงเกี่ยวกับความเป็นส่วนตัวของพวกเขา',
      },
      {
        subHeader: 'ความปลอดภัย',
        subContent:
          'เพื่อปกป้องข้อมูลส่วนบุคคลของคุณ เราดำเนินมาตรการป้องกันที่สมเหตุสมผลและปฏิบัติตามแนวทางปฏิบัติที่ดีที่สุดในอุตสาหกรรม เพื่อให้แน่ใจว่าข้อมูลของคุณจะไม่สูญหาย ถูกนำไปใช้ในทางที่ผิด ถูกเข้าถึง เปิดเผย เปลี่ยนแปลง หรือถูกทำลายโดยไม่เหมาะสม',
      },
      {
        subHeader: 'คุกกี้',
        subContent:
          'เราใช้คุกกี้เพื่อรักษาเซสชันของผู้ใช้ของคุณ มันไม่ได้ใช้เพื่อระบุตัวตนของคุณในเว็บไซต์อื่น',
      },
      {
        subHeader: 'อายุของการให้ความยินยอม',
        subContent:
          'โดยการใช้เว็บไซต์นี้ คุณรับรองว่าคุณมีอายุถึงเกณฑ์บรรลุนิติภาวะในรัฐหรือจังหวัดที่คุณพำนัก หรือว่าคุณมีอายุถึงเกณฑ์และได้ให้ความยินยอมให้ผู้เยาว์ที่อยู่ในความดูแลของคุณใช้เว็บไซต์นี้',
      },
      {
        subHeader: 'การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้',
        subContent:
          'เราขอสงวนสิทธิ์ในการเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลา ดังนั้นโปรดตรวจสอบเป็นระยะ ๆ การเปลี่ยนแปลงและการชี้แจงจะมีผลทันทีเมื่อโพสต์บนเว็บไซต์ หากเราทำการเปลี่ยนแปลงที่สำคัญในนโยบายนี้ เราจะแจ้งให้คุณทราบที่นี่ เพื่อให้คุณรับทราบว่าข้อมูลใดที่เรารวบรวม วิธีที่เราใช้ และภายใต้สถานการณ์ใด (ถ้ามี) ที่เราใช้หรือเปิดเผยข้อมูลนั้น หากร้านค้าของเราถูกซื้อหรือควบรวมกับบริษัทอื่น ข้อมูลของคุณอาจถูกโอนไปยังเจ้าของใหม่เพื่อให้เราสามารถขายผลิตภัณฑ์ให้คุณต่อไปได้',
      },
      {
        subHeader: 'คำถามและข้อมูลติดต่อ',
        subContent:
          'หากคุณต้องการเข้าถึง แก้ไข เปลี่ยนแปลง หรือลบข้อมูลส่วนบุคคลของคุณที่เรามีเกี่ยวกับคุณ แจ้งเรื่องร้องเรียน หรือขอข้อมูลเพิ่มเติม กรุณาติดต่อเจ้าหน้าที่ฝ่ายความเป็นส่วนตัวของเราที่ support.th@wisedrive.com',
      },
    ],
  },
  reportData: {
    reportFor: 'รายงานสำหรับ',
    inspectedBy: 'ตรวจสอบโดย',
    marketValue: 'มูลค่าตลาด',
    overallRating: 'คะแนนรวม',
    recommendedToBuy: 'แนะนำให้ซื้อ',
    inspectionDetailsTitle: 'รายละเอียดการตรวจสอบ',
    mechanicName: 'ช่างผู้ตรวจสอบ',
    inspectionDate: 'วันที่ตรวจสอบ',
    requestedDate: 'วันที่ร้องขอ',
    location: 'สถานที่',
    inspectionSummaryTitle: 'สรุปการตรวจสอบ',
    checkpointsInspected: 'ตรวจสอบมากกว่า 200 จุด',
    assessmentTitle: 'การประเมิน',
    vehicleInformationTitle: 'ข้อมูลรถยนต์',
    make: 'ยี่ห้อ',
    owners: 'เจ้าของ',
    model: 'รุ่น',
    transmission: 'ระบบเกียร์',
    year: 'ปี',
    regNo: 'เลขทะเบียน',
    mfgDate: 'วันที่ผลิต',
    fuel: 'ประเภทเชื้อเพลิง',
    colour: 'สี',
    regDate: 'วันที่จดทะเบียน',
    engineCC: 'ขนาดเครื่องยนต์ (CC)',
    engineNumber: 'หมายเลขเครื่องยนต์',
    chassisNo: 'หมายเลขแชสซี',
    keyInformation: 'ข้อมูลสำคัญ',
    kmsDriven: 'ระยะทางที่ขับขี่ (กม.)',
    majorAccident: 'อุบัติเหตุใหญ่',
    floodDamage: 'ความเสียหายจากน้ำท่วม',
    engineCondition: 'สภาพเครื่องยนต์',
    transmission: 'ระบบเกียร์',
    exteriorCondition: 'สภาพภายนอก',
    interiorCondition: 'สภาพภายใน',
    dentsScratches: 'รอยบุบและรอยขีดข่วน',
    avgTyreLife: 'อายุการใช้งานยางเฉลี่ย',
    insurance: 'ประกันภัย',
    majorRepair: 'การซ่อมแซมใหญ่',
    minorRepair: 'การซ่อมแซมเล็กน้อย',
    obd2ScanningReport: 'รายงานการสแกน OBD2',
    easy: 'อ่านง่าย',
    made: 'ออกแบบเพื่อให้เข้าใจง่ายทุกข้อมูลในรายงานตรวจสอบของคุณบนมือถือ',
    track: 'ติดตามง่าย',
    trackMade: 'รับรายละเอียดค่าใช้จ่ายหลังการซื้อก่อนตัดสินใจซื้อรถยนต์มือสอง',
    report: 'รายงานโดยละเอียด',
    reportMade:
      'รายงานนี้สร้างขึ้นจากการตรวจสอบทางกายภาพ, AI, การสแกน OBD2 ด้วยอุปกรณ์ทันสมัย',
    dec1Content: (
      <>
        <p style={{ paddingTop: '0px' }}>
          บริษัท ไวส์ไดรฟ์ เทคโนโลยีส์ (เอ็ม) จำกัด
        </p>
        <p style={{ paddingTop: '0px' }}>ล็อต 2F, ถนน 215, เขต 51,</p>
        <p style={{ paddingTop: '0px' }}>เปตาลิงจายา, รัฐเซอลาโงร์</p>
        <p style={{ paddingTop: '0px' }}>ประเทศมาเลเซีย 46050</p>
      </>
    ),
  },
};
